(function() {
  if (window.Shopify && window.Shopify.designMode) return;

  // §8 (2026-08-04): build version reads the theme stamp set inline in
  // theme.liquid (single source of truth) — no more per-file literals.
  var JRS_BUILD_VERSION = String(window._bcThemeVersion || 'JRSBASE-V8.3.0-09102026-BYOB').replace(/^\d+-/, '');
  var JRS_THEME_NAME = 'base';

  const BATCH_SIZE = 10;
  const INITIAL_VISIBLE = 12;
  const INITIAL_VISIBLE_MOBILE = 12; // was 8 — raised to match desktop (operator ruling 2026-08-29)
  // Preview-bar size-tag truncation (operator ruling 2026-08-31). Desktop 24 ≈
  // two rows at the measured preview-bar width (12–13 tags/row at 352px);
  // mobile 12 ≈ three rows at 360px per the task spec.
  const PREVIEW_SIZES_VISIBLE = 24;
  const PREVIEW_SIZES_VISIBLE_MOBILE = 12;
  const MOBILE_BREAKPOINT = 768;
  const STICKY_THRESHOLD = 200;
  // One-size swatch strip geometry — keep in sync with .pdp-v2__pvos-swatch CSS.
  const SWATCH_SIZE_PX = 34;
  const SWATCH_GAP_PX = 8;
  const LIGHT_NAMES = ['white', 'heather', 'sky', 'arctic white', 'candyfloss', 'dusty pink'];
  var GARMENT_DISCOUNT_TIERS = [
    { minQty: 1, discount: 0, label: '—' },
    { minQty: 10, discount: 5, label: '5% off' },
    { minQty: 25, discount: 10, label: '10% off' },
    { minQty: 50, discount: 20, label: '20% off' }
  ];

  var STATIC_HEX_MAP = {
    'Black': '#000', 'BLACK': '#000', 'White': '#fafafa', 'WHITE': '#fafafa', 'Navy': '#102C54', 'NAVY': '#102C54',
    'Red': '#ff0000', 'RED': '#ff0000', 'Blue': '#0000ff', 'BLUE': '#0000ff', 'Orange': '#FF8C00', 'ORANGE': '#FF8C00',
    'Green': '#007500', 'GREEN': '#007500', 'Yellow': '#ffd400', 'YELLOW': '#ffd400', 'Grey': '#888B8D', 'Gray': '#888B8D',
    'Light Grey': '#999', 'LIGHT GREY': '#999', 'Heather Grey': '#B1B3B3', 'Heather Grey': '#A8ADB4', 'Charcoal': '#414B56', 'Graphite Grey': '#4B4E53',
    'Burgundy': '#800020', 'BURGUNDY': '#800020', 'Purple': '#5D538B', 'PURPLE': '#A020F0', 'Pink': '#FEBBCA',
    'Olive': '#7E9051', 'OLIVE': '#7E9051', 'Brown': '#372B27', 'Royal': '#0047B6', 'Royal Blue': '#003594',
    'Sapphire': '#00A3E0', 'Sapphire Blue': '#009ACF', 'Sky': '#92C9EB', 'Sky Blue': '#9BB8D3', 'Natural': '#E5D3BF',
    'NATURAL': '#E5D3BF', 'Khaki': '#7A7256', 'Sand': '#C6B9AC', 'Beige': '#BFBB98', 'Mustard': '#C69214',
    'Lime': '#84BD00', 'Kelly Green': '#16A34A', 'Electric Green': '#97D700', 'Hot Pink': '#E0218A',
    'French Navy': '#13294B', 'French Navy': '#041C2C', 'Navy Blue': '#102C54', 'Classic Red': '#ff0000', 'Maroon': '#752641',
    'Ash': '#D0D0CE', 'Stone': '#D1CCBD', 'Silver': '#A2AAAD', 'Gold': '#FFBF3F', 'Teal': '#006980',
    'Camel': '#A47449', 'Mocha': '#5E4B3C', 'Lilac': '#D8CBEB', 'Coral': '#FF5C39', 'Mint Green': '#3CDBC0',
    'Dusty Pink': '#C58B93', 'Dusty Blue': '#798EA4', 'Arctic White': '#FFFFFF', 'Sport Grey': '#97999B',
    'Graphite': '#41424C', 'Ebony': '#39373b', 'Jet Black': '#0A0A0A', 'Deep Navy': '#051c2c',
    'Bottle Green': '#032D23', 'Forest Green': '#13322B', 'Emerald': '#50c878', 'Hi-Vis Yellow': '#ccff00',
    'Hi-Vis Orange': '#ff7800', 'Hi-Vis Red': '#ff0000', 'Fluorescent Orange': '#FF8F6C', 'Fluorescent Yellow': '#E3E829',
    'Reflex Blue': '#001489', 'Oxford Navy': '#1B365D', 'Anthracite': '#383838', 'Taupe': '#94795D',
    'Green/Dark Green': '#007500', 'Charcoal/Black': '#414B56', 'BRIGHT ROYAL': '#4169e1', 'Candy Floss': '#E45C96',
    'Antique Cherry Red': '#9B2335', 'Antique Sapphire': '#2E5090', 'Azalea': '#F9C0C4', 'Carolina Blue': '#57A0D2',
    'Cherry Red': '#C41E3A', 'Cardinal Red': '#C41E3A', 'Daisy': '#FFE135', 'Dark Chocolate': '#3D2314',
    'Dark Heather': '#4A4A4A'
  };

  function handleize(s) {
    if (!s || typeof s !== 'string') return '';
    return s.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '') || '';
  }
  function lookupHex(colorName, hexMap, staticMap) {
    if (!colorName) return '#999';
    if (hexMap) {
      var h = hexMap[colorName] || hexMap[colorName.toLowerCase()];
      if (h) return h;
    }
    var colorH = handleize(colorName);
    for (var k in staticMap) {
      if (k === colorName || (k || '').toLowerCase() === (colorName || '').toLowerCase()) return staticMap[k];
      if (handleize(k) === colorH) return staticMap[k];
    }
    return '#999';
  }

  function hexToRgb(hex) {
    const m = hex.slice(1).match(/.{2}/g);
    if (!m) return { r: 0, g: 0, b: 0 };
    return { r: parseInt(m[0], 16), g: parseInt(m[1], 16), b: parseInt(m[2], 16) };
  }
  function isLightColor(hex) {
    if (!hex || typeof hex !== 'string') return false;
    const name = hex.toLowerCase();
    const rgb = hexToRgb(hex.startsWith('#') ? hex : '#' + hex);
    const luminance = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
    return luminance > 186 || LIGHT_NAMES.some(function(n) { return name.indexOf(n) !== -1; });
  }

  class PdpMultistepFormV2 extends HTMLElement {
    constructor() {
      super();
      this._state = {
        step: 1,
        selectedColor: null,
        quantities: {},
        visibleCount: INITIAL_VISIBLE,
        drawerOpen: false,
        previewColor: null,
        stickyVisible: false
      };
      this._data = null;
      this._colors = [];
      this._scrollHandler = null;
      this._resizeHandler = null;
    }

    connectedCallback() {
      var configEl = this.querySelector('script[data-pdp-v2-config]');
      if (!configEl || !configEl.textContent || !configEl.textContent.trim()) {
        this.setAttribute('data-pdp-v2-error', 'no-config');
        this._showError();
        return;
      }
      try {
        this._data = JSON.parse(configEl.textContent.trim());
        this._data.variants = [];
        var hexArr = this._data.hexMapArray || [];
        var imgArr = this._data.variantImagesArray || [];
        this._data.hexMap = {};
        this._data.variantImages = {};
        for (var i = 0; i < hexArr.length; i++) {
          var p = hexArr[i];
          if (p && p.name != null) this._data.hexMap[p.name] = p.hex || '#999';
        }
        for (var j = 0; j < imgArr.length; j++) {
          var q = imgArr[j];
          if (q && q.name != null) this._data.variantImages[q.name] = q.url || '';
        }
      } catch (e) {
        this.setAttribute('data-pdp-v2-error', 'parse');
        if (typeof console !== 'undefined' && console.error) {
          console.error('[PdpMultistepFormV2] Config JSON parse failed:', e.message);
        }
        this._showError();
        return;
      }
      var self = this;
      var handle = this._data.productHandle;
      var colorIdx = this._data.colorOptionIndex != null ? this._data.colorOptionIndex : 0;
      if (handle) {
        // Prefer the GraphQL helper from jrs-bundle-size-grid.js — it paginates
        // past the 250-variant cap that limits product.variants Liquid output and
        // /products/{handle}.json. Required for products like JH001 (~730 variants)
        // where sizes beyond slot 250 silently drop out of the per-colour grid.
        var gqlFetch = window.JRS && window.JRS.BundleSizeGrid && window.JRS.BundleSizeGrid.fetchProduct;
        if (typeof gqlFetch === 'function') {
          gqlFetch(handle)
            .then(function(product) {
              if (product && Array.isArray(product.variants)) {
                self._data.variants = product.variants;
                var variants = product.variants;
                for (var v = 0; v < variants.length; v++) {
                  var variant = variants[v];
                  var colorName = (variant.options && variant.options[colorIdx]) ? variant.options[colorIdx] : (variant.option1 || '');
                  if (!colorName) continue;
                  var imgUrl = (variant.featured_image && (variant.featured_image.src || variant.featured_image.url)) || '';
                  if (imgUrl && !self._data.variantImages[colorName]) self._data.variantImages[colorName] = imgUrl;
                }
              }
              self._initAfterVariants();
            })
            .catch(function() {
              self._initAfterVariants();
            });
        } else {
          fetch('/products/' + encodeURIComponent(handle) + '.json')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data && data.product && Array.isArray(data.product.variants)) {
                self._data.variants = data.product.variants;
                var product = data.product;
                var mainImg = (product.featured_image && (product.featured_image.src || product.featured_image.url)) ||
                  (product.images && product.images[0] && (product.images[0].src || product.images[0].url));
                if (mainImg) self._data.mainProductImage = mainImg;
                var variants = product.variants;
                for (var v = 0; v < variants.length; v++) {
                  var variant = variants[v];
                  var colorName = (variant.options && variant.options[colorIdx]) ? variant.options[colorIdx] : (variant.option1 || '');
                  if (!colorName) continue;
                  var imgUrl = (variant.featured_image && (variant.featured_image.src || variant.featured_image.url)) ||
                    (variant.image && (variant.image.src || variant.image.url)) ||
                    '';
                  if (imgUrl) self._data.variantImages[colorName] = imgUrl;
                }
                if (product.images && Array.isArray(product.images)) {
                  for (var i = 0; i < product.images.length; i++) {
                    var img = product.images[i];
                    var url = img.src || img.url || '';
                    if (!url) continue;
                    var vids = img.variant_ids || [];
                    for (var k = 0; k < vids.length; k++) {
                      var vid = vids[k];
                      for (var v2 = 0; v2 < variants.length; v2++) {
                        if (variants[v2].id === vid) {
                          var c = (variants[v2].options && variants[v2].options[colorIdx]) ? variants[v2].options[colorIdx] : (variants[v2].option1 || '');
                          if (c) self._data.variantImages[c] = url;
                          break;
                        }
                      }
                    }
                  }
                }
              }
              self._initAfterVariants();
            })
            .catch(function() {
              self._initAfterVariants();
            });
        }
      } else {
        this._initAfterVariants();
      }
    }

    _initAfterVariants() {
      this._deriveColors();
      if (this._colors.length === 1) {
        this._state.selectedColor = this._colors[0];
      }
      this._state.visibleCount = window.innerWidth < MOBILE_BREAKPOINT ? INITIAL_VISIBLE_MOBILE : INITIAL_VISIBLE;
      this._renderStep1();
      this._renderProgress();
      this._renderStickyFooter();
      if (this._state.selectedColor && this._colors.length === 1 && typeof requestAnimationFrame !== 'undefined') {
        var self = this;
        requestAnimationFrame(function() { self._syncGalleryToColor(self._state.selectedColor); });
      }
      this._bindStep1();
      this._bindGlobal();
      this._closeDrawer();
      this._closePreview();
      this._onScroll();
      this._scrollHandler = this._onScroll.bind(this);
      this._resizeHandler = this._onResize.bind(this);
      this._keyHandler = this._onKeydown.bind(this);
      this._cvdDrawerOpenedHandler = this._notifyVolumeDrawer.bind(this);
      window.addEventListener('scroll', this._scrollHandler, { passive: true });
      window.addEventListener('resize', this._resizeHandler);
      document.addEventListener('keydown', this._keyHandler);
      document.addEventListener('cvd-drawer-opened', this._cvdDrawerOpenedHandler);
      this.setAttribute('data-current-step', String(this._state.step));
      this.setAttribute('data-pdp-v2-ready', 'true');

      // Single-colour product: there's no colour choice to make, so skip the
      // "Choose Colour" step and land the shopper directly on size selection.
      // The colour is already pre-selected above; advance without a scroll jump
      // (the user didn't click anything). Multi-colour products are unchanged.
      if (this._colors.length === 1 && this._state.selectedColor) {
        this._goStep2(true);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._scrollHandler);
      window.removeEventListener('resize', this._resizeHandler);
      document.removeEventListener('keydown', this._keyHandler);
      document.removeEventListener('cvd-drawer-opened', this._cvdDrawerOpenedHandler);
    }

    _bindGlobal() {
      var self = this;
      this.addEventListener('click', function(e) {
        var rawTarget = e.target || null;
        var target = rawTarget && rawTarget.nodeType === 1 ? rawTarget : (rawTarget && rawTarget.parentElement ? rawTarget.parentElement : null);
        if (!target || typeof target.closest !== 'function') return;

        if (target.closest('[data-pdp-v2-atc]')) { e.preventDefault(); self._handleATC(); }
        if (target.closest('[data-pdp-v2-sticky-atc]')) {
          e.preventDefault();
          var stickyBtn = target.closest('[data-pdp-v2-sticky-atc]');
          if (self._state.step === 1 && !self._state.selectedColor) {
            self._scrollToMountWithHeaderOffset();
          } else if (self._state.step === 1 && self._state.selectedColor) {
            self._goStep2();
          } else if (stickyBtn && stickyBtn.getAttribute('data-pdp-v2-sticky-action') === 'select-sizes') {
            self._scrollToMountWithHeaderOffset();
          } else {
            self._handleATC();
          }
        }
        if (target.closest('[data-pdp-v2-drawer-close]')) { e.preventDefault(); self._closeDrawer(); }
        if (target.closest('[data-pdp-v2-modal-close]')) { e.preventDefault(); self._closePreview(); }
        var sizeGuideLink = target.closest('[data-pdp-v2-size-guide]');
        if (sizeGuideLink) {
          e.preventDefault();
          // 2026-08-29: route through the shared size-guide opener
          // (size-popup.liquid) — visibility check + instrumentation. The
          // multistep PDP has no .mrk-sizing-btn, so the old path opened the
          // popup directly and fired no events.
          if (typeof window.jrsOpenSizeGuide === 'function') {
            window.jrsOpenSizeGuide({ surface: 'pdp' });
          } else {
            var sizingBtn = document.querySelector('.mrk-sizing-btn');
            if (sizingBtn) {
              sizingBtn.click();
            } else {
              var popup = document.getElementById('size-popup');
              if (popup) popup.classList.add('show');
            }
          }
        }
        var previewViewBtn = target.closest('[data-pdp-v2-preview-view]');
        if (previewViewBtn && self._state.selectedColor) {
          e.preventDefault();
          self._openPreview(self._state.selectedColor);
        }
        if (target.closest('[data-pdp-v2-change-colour]')) {
          e.preventDefault();
          self._goStep1(); // back to Step 1 (colour grid) to pick another colour
          return;
        }
        var showMoreBtn = target.closest('[data-pdp-v2-show-more-btn], .pdp-v2__show-more-btn');
        var viewAllBtn = target.closest('[data-pdp-v2-viewall], .pdp-v2__show-more-btn--viewall');
        if (showMoreBtn && !viewAllBtn) {
          e.preventDefault();
          self._state.visibleCount = Math.min(self._state.visibleCount + BATCH_SIZE, self._colors.length);
          self._renderStep1();
        } else if (viewAllBtn) {
          e.preventDefault();
          self._openDrawer();
        }
      });
      var card = this.querySelector('[data-pdp-v2-modal-card]');
      if (card) card.addEventListener('click', function(e) {
        if (!e.target.closest('[data-pdp-v2-modal-close]')) e.stopPropagation();
      });
    }

    _onKeydown(e) {
      if (e.key !== 'Escape') return;
      this._closeDrawer();
      this._closePreview();
    }

    _showError() {
      this.setAttribute('data-pdp-v2-ready', 'true');
      var card = this.querySelector('.pdp-v2__step1 .pdp-v2__card');
      if (card) {
        card.innerHTML = '<p class="pdp-v2__helper">Something went wrong. <button type="button" class="pdp-v2__pill-view" onclick="window.location.reload()">Reload to try again</button>.</p>';
      }
    }

    _deriveColors() {
      var v = this._data.variants || [];
      var ci = this._data.colorOptionIndex || 0;
      var hexMap = this._data.hexMap || {};
      var imgMap = this._data.variantImages || {};
      var seen = {};
      for (var i = 0; i < v.length; i++) {
        var name = v[i].options && v[i].options[ci] ? v[i].options[ci] : (v[i].option1 || '');
        if (!name || seen[name]) continue;
        seen[name] = true;
        var hex = hexMap[name] || hexMap[name.toLowerCase()] || lookupHex(name, hexMap, STATIC_HEX_MAP);
        if (hex && hex.indexOf('#') !== 0) hex = '#' + hex;
        this._colors.push({
          name: name,
          hex: hex || '#999',
          image: imgMap[name] || imgMap[name.toLowerCase()] || '',
          available: v[i].available !== false
        });
      }
      // Popularity ordering (shared utility from jrs-colour-order.liquid):
      // listed colours in list order, unlisted keep Shopify's relative order.
      if (typeof window.jrsSortColours === 'function') {
        this._colors = window.jrsSortColours(this._colors, function (c) { return c.name; });
      }
    }

    _parseVariantPrice(raw) {
      if (raw == null || raw === '') return 0;
      var str = String(raw).trim();
      var num = parseFloat(str, 10) || 0;
      if (num <= 0) return 0;
      if (str.indexOf('.') !== -1) return num;
      if (num < 100) return num;
      return num / 100;
    }

    _getSizesForColor(colorName) {
      var v = this._data.variants || [];
      var ci = this._data.colorOptionIndex || 0;
      var si = this._data.sizeOptionIndex !== undefined ? this._data.sizeOptionIndex : 1;
      var list = [];
      var seen = {};
      for (var i = 0; i < v.length; i++) {
        var c = v[i].options && v[i].options[ci] ? v[i].options[ci] : (v[i].option1 || '');
        if ((c || '').toLowerCase() !== (colorName || '').toLowerCase()) continue;
        var label = v[i].options && v[i].options[si] ? v[i].options[si] : (v[i].option2 || v[i].option1 || '');
        if (seen[label]) continue;
        seen[label] = true;
        var price = this._parseVariantPrice(v[i].price);
        var variantId = v[i].id;
        var invMap = this._data.variantInventory;
        var bootstrapInv = invMap && (invMap[variantId] !== undefined ? invMap[variantId] : invMap[String(variantId)]);
        var qty;
        var stockKnown;
        if (bootstrapInv !== undefined && bootstrapInv !== null && bootstrapInv !== '') {
          qty = Number(bootstrapInv) || 0;
          stockKnown = true;
        } else {
          qty = v[i].inventory_quantity;
          stockKnown = true;
          if (qty == null || qty === '') {
            var avail = v[i].available !== undefined ? v[i].available : v[i].available_for_sale;
            if (avail === false || avail === 'false') {
              qty = 0;
            } else if (v[i].quantity_available != null && v[i].quantity_available !== '') {
              qty = Number(v[i].quantity_available) || 0;
            } else {
              qty = 999;
              stockKnown = false;
            }
          } else {
            qty = Number(qty) || 0;
          }
        }
        list.push({
          label: label,
          stock: qty,
          stockKnown: stockKnown,
          price: price,
          popular: false,
          variantId: v[i].id
        });
      }
      return list;
    }

    _renderStep1() {
      var grid = this.querySelector('[data-pdp-v2-color-grid]');
      var showMore = this.querySelector('[data-pdp-v2-show-more]');
      if (!grid) return;
      var count = Math.min(this._state.visibleCount, this._colors.length);
      var visible = this._colors.slice(0, count);
      grid.innerHTML = '';
      var self = this;
      visible.forEach(function(c) {
        var pill = self._createColorPill(c);
        grid.appendChild(pill);
      });
      var remaining = this._colors.length - count;
      if (remaining <= 0) {
        showMore.hidden = true;
        showMore.innerHTML = '';
      } else {
        showMore.hidden = false;
        if (remaining <= BATCH_SIZE) {
          showMore.innerHTML = '<button type="button" class="pdp-v2__show-more-btn" data-pdp-v2-show-more-btn="">Show ' + remaining + ' more colour' + (remaining !== 1 ? 's' : '') + ' \u2193</button>';
        } else {
          showMore.innerHTML = '<button type="button" class="pdp-v2__show-more-btn" data-pdp-v2-show-more-btn="">Show ' + BATCH_SIZE + ' more \u2193</button><button type="button" class="pdp-v2__show-more-btn pdp-v2__show-more-btn--viewall" data-pdp-v2-viewall="">View all ' + this._colors.length + ' colours</button>';
        }
      }
      this._renderPreviewBar();
      this._updateContinueButton();
    }

    _renderPreviewBar() {
      var bar = this.querySelector('[data-pdp-v2-preview-bar]');
      if (!bar) return;
      var color = this._state.selectedColor;
      if (!color) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;
      var sizes = this._getSizesForColor(color.name);
      var available = sizes.filter(function(s) { return s.stock > 0; });
      // One-size products get the reduced colour row (operator design,
      // 2026-09-01): no pricing (the quantity block owns it), larger image,
      // and an inline swatch strip. The shared multi-size row below is
      // untouched — it still carries "From £" and the stats bar because
      // multi-size has no quantity block doing that work.
      var innerEl = bar.querySelector('.pdp-v2__preview-bar-inner');
      var pvosEl = bar.querySelector('[data-pdp-v2-pvos]');
      if (sizes.length === 1) {
        if (innerEl) innerEl.style.display = 'none';
        bar.classList.add('pdp-v2__preview-bar--onesize');
        this._renderOneSizePreview(bar, color);
        return;
      }
      bar.classList.remove('pdp-v2__preview-bar--onesize');
      if (pvosEl) pvosEl.remove();
      if (innerEl) innerEl.style.display = '';
      var minPrice = available.length ? Math.min.apply(null, available.map(function(s) { return s.price; })) : 0;
      var light = isLightColor(color.hex);
      // Prefer last tier from CVD table (same as volume discount drawer: 500+, 40% Off)
      var discountValue = '\u2014';
      var discountSub = '';
      var cvdTable = document.getElementById('cvdTable-garment');
      if (cvdTable) {
        var cvdRows = cvdTable.querySelectorAll('.cvd-table-row[data-min][data-max]');
        if (cvdRows.length) {
          var lastRow = cvdRows[cvdRows.length - 1];
          var qtyEl = lastRow.querySelector('.cvd-table-qty');
          var discEl = lastRow.querySelector('.cvd-table-discount:not(.none)');
          if (qtyEl && qtyEl.textContent) discountValue = qtyEl.textContent.trim();
          if (discEl && discEl.textContent) discountSub = discEl.textContent.trim();
        }
      }
      if (discountValue === '\u2014' || discountSub === '') {
        var tiers = this._data.discountTiers || GARMENT_DISCOUNT_TIERS;
        var lastTier = null;
        if (tiers && tiers.length) {
          for (var t = tiers.length - 1; t >= 0; t--) {
            if (tiers[t].discount != null && tiers[t].discount > 0) {
              lastTier = tiers[t];
              break;
            }
          }
          if (!lastTier) lastTier = tiers[tiers.length - 1];
        }
        if (lastTier) {
          if (discountValue === '\u2014') discountValue = lastTier.minQty != null ? lastTier.minQty + '+' : '\u2014';
          if (discountSub === '') discountSub = lastTier.discount != null && lastTier.discount > 0 ? lastTier.discount + '% Off' : '';
        }
      }

      var imgEl = this.querySelector('[data-pdp-v2-preview-image]');
      if (imgEl) {
        imgEl.innerHTML = '';
        imgEl.style.background = 'linear-gradient(135deg, ' + color.hex + '12, ' + color.hex + '40)';
        var block = document.createElement('div');
        block.className = 'pdp-v2__preview-bar-color-block';
        block.style.background = color.hex;
        if (light) block.style.border = '1.5px solid #e5e5e5';
        if (color.image && color.image.trim()) {
          var img = document.createElement('img');
          img.src = color.image;
          img.alt = color.name;
          img.loading = 'eager';
          img.onerror = function() { block.textContent = '\uD83D\uDC55'; block.style.fontSize = '24px'; block.style.color = light ? '#737373' : 'rgba(255,255,255,0.25)'; };
          block.appendChild(img);
        } else {
          block.textContent = '\uD83D\uDC55';
          block.style.fontSize = '24px';
          block.style.color = light ? '#737373' : 'rgba(255,255,255,0.25)';
        }
        imgEl.appendChild(block);
        var badge = document.createElement('div');
        badge.className = 'pdp-v2__preview-bar-badge';
        badge.innerHTML = '<svg width="11" height="11" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#16a34a"/><path d="M4.5 8.5L7 11L11.5 5.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Selected</span>';
        imgEl.appendChild(badge);
      }

      var swatchEl = this.querySelector('[data-pdp-v2-preview-swatch]');
      if (swatchEl) {
        swatchEl.style.background = color.hex;
        swatchEl.style.border = light ? '1px solid #d4d4d4' : 'none';
      }
      var nameEl = this.querySelector('[data-pdp-v2-preview-name]');
      if (nameEl) nameEl.textContent = color.name;
      var priceEl = this.querySelector('[data-pdp-v2-preview-price]');
      if (priceEl) priceEl.textContent = 'From \u00a3' + minPrice.toFixed(2);

      var sizesEl = this.querySelector('[data-pdp-v2-preview-sizes]');
      if (sizesEl) {
        sizesEl.innerHTML = '';
        var self = this;
        // Truncation (2026-08-31): display-only summary, catalogue order kept.
        // Same constant shape as the colour grid's INITIAL_VISIBLE pair.
        var sizeLimit = window.innerWidth < MOBILE_BREAKPOINT ? PREVIEW_SIZES_VISIBLE_MOBILE : PREVIEW_SIZES_VISIBLE;
        var truncatable = sizes.length > sizeLimit;
        var sizesExpanded = !!this._state.previewSizesExpanded;
        sizesEl.classList.toggle('pdp-v2__preview-bar-sizes--truncated', truncatable && !sizesExpanded);
        sizes.forEach(function(s, idx) {
          var soldOut = s.stock === 0;
          var low = s.stock > 0 && s.stock <= 10;
          var tag = document.createElement('span');
          tag.className = 'pdp-v2__preview-bar-size-tag' + (soldOut ? ' pdp-v2__preview-bar-size-tag--soldout' : '') + (low ? ' pdp-v2__preview-bar-size-tag--low' : '') + (s.popular ? ' pdp-v2__preview-bar-size-tag--popular' : '');
          if (truncatable && !sizesExpanded && idx >= sizeLimit) {
            tag.className += ' pdp-v2__preview-bar-size-tag--hidden';
          }
          tag.textContent = s.label;
          sizesEl.appendChild(tag);
        });
        var stockNote = document.createElement('span');
        stockNote.className = 'pdp-v2__preview-bar-stock-note';
        stockNote.textContent = available.length + '/' + sizes.length + ' in stock';
        sizesEl.appendChild(stockNote);
        if (truncatable) {
          var sizesToggle = document.createElement('button');
          sizesToggle.type = 'button';
          sizesToggle.className = 'pdp-v2__preview-bar-sizes-toggle';
          sizesToggle.setAttribute('data-pdp-v2-sizes-toggle', '');
          sizesToggle.textContent = sizesExpanded
            ? 'Show fewer sizes ↑'
            : '+' + (sizes.length - sizeLimit) + ' more sizes ↓';
          sizesToggle.addEventListener('click', function(e) {
            e.preventDefault();
            self._state.previewSizesExpanded = !self._state.previewSizesExpanded;
            self._renderPreviewBar();
          });
          sizesEl.appendChild(sizesToggle);
        }
      }

      var statSizes = this.querySelector('[data-pdp-v2-preview-stat-sizes]');
      if (statSizes) {
        // "SIZES · 1 of 1 · in stock" conveys nothing on a one-size product —
        // hide the stat there (2026-08-31); multi-size unchanged.
        if (sizes.length === 1) {
          statSizes.innerHTML = '';
          statSizes.style.display = 'none';
        } else {
          statSizes.style.display = '';
          statSizes.innerHTML = '<span class="pdp-v2__preview-bar-stat-label">Sizes</span><span class="pdp-v2__preview-bar-stat-value">' + available.length + ' of ' + sizes.length + '</span><span class="pdp-v2__preview-bar-stat-sub">in stock</span>';
        }
      }
      var statPrice = this.querySelector('[data-pdp-v2-preview-stat-price]');
      if (statPrice) statPrice.innerHTML = '<span class="pdp-v2__preview-bar-stat-label">Starts at</span><span class="pdp-v2__preview-bar-stat-value">\u00a3' + minPrice.toFixed(2) + '</span><span class="pdp-v2__preview-bar-stat-sub">per unit</span>';
      var statDiscount = this.querySelector('[data-pdp-v2-preview-stat-discount]');
      if (statDiscount) {
        // Ineligible products (no garment volume offer): no BULK DISCOUNT
        // stat — hidden entirely, same pattern as the one-size SIZES stat.
        if (!this._isVolumeEligible()) {
          statDiscount.innerHTML = '';
          statDiscount.style.display = 'none';
        } else {
          statDiscount.style.display = '';
          statDiscount.innerHTML = '<span class="pdp-v2__preview-bar-stat-label">Bulk discount</span><span class="pdp-v2__preview-bar-stat-value">' + discountValue + '</span><span class="pdp-v2__preview-bar-stat-sub">' + discountSub + '</span>';
        }
      }
    }

    // Shopify CDN image at an explicit width — request the small rendition,
    // never a full-size image scaled down in CSS (BAY-01: this page already
    // ships 2.6MB behind 12 blocking scripts; swatches must stay cheap).
    _sizedImageUrl(url, width) {
      if (!url) return '';
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + width);
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    // One-size colour row (operator design, 2026-09-01): larger image, no
    // pricing, inline swatch strip below a divider. "Change colour" renders
    // only when a "+N more" chip does — a drawer showing the same swatches
    // already on screen is noise.
    _renderOneSizePreview(bar, color) {
      var pvos = bar.querySelector('[data-pdp-v2-pvos]');
      if (!pvos) {
        pvos = document.createElement('div');
        pvos.className = 'pdp-v2__pvos';
        pvos.setAttribute('data-pdp-v2-pvos', '');
        bar.appendChild(pvos);
      }
      pvos.innerHTML = '';
      var light = isLightColor(color.hex);

      var row = document.createElement('div');
      row.className = 'pdp-v2__pvos-row';

      var imgWrap = document.createElement('div');
      imgWrap.className = 'pdp-v2__pvos-img';
      if (color.image && color.image.trim()) {
        var img = document.createElement('img');
        img.src = this._sizedImageUrl(color.image, 152);
        img.alt = color.name;
        img.loading = 'eager';
        img.onerror = function() { img.remove(); imgWrap.style.background = color.hex || '#E5E5E5'; };
        imgWrap.appendChild(img);
      } else {
        imgWrap.style.background = color.hex || '#E5E5E5';
        if (light) imgWrap.style.boxShadow = 'inset 0 0 0 1.5px #e5e5e5';
      }
      row.appendChild(imgWrap);

      var info = document.createElement('div');
      info.className = 'pdp-v2__pvos-info';
      var eyebrow = document.createElement('div');
      eyebrow.className = 'pdp-v2__pvos-eyebrow';
      eyebrow.textContent = 'Your colour';
      var nameEl = document.createElement('div');
      nameEl.className = 'pdp-v2__pvos-name';
      nameEl.textContent = color.name;
      var subEl = document.createElement('div');
      subEl.className = 'pdp-v2__pvos-sub';
      var oneSizeSpan = document.createElement('span');
      oneSizeSpan.textContent = 'One size';
      subEl.appendChild(oneSizeSpan);
      // Prominent per operator ruling 2026-09-01: leading expand icon
      // (aria-hidden — the accessible name stays the text).
      var viewIcon = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';
      // Mobile-only "View full image" ON ITS OWN ROW below "One size"
      // (amendment 2026-09-01: sharing the sub row wrapped the link badly at
      // 375 — icon beside the size text, label on the next line). One icon
      // only — no trailing arrow on this copy.
      var viewInline = document.createElement('button');
      viewInline.type = 'button';
      viewInline.className = 'pdp-v2__pvos-view pdp-v2__pvos-view--inline';
      viewInline.setAttribute('data-pdp-v2-preview-view', '');
      viewInline.innerHTML = viewIcon + '<span>View full image</span>';
      info.appendChild(eyebrow);
      info.appendChild(nameEl);
      info.appendChild(subEl);
      info.appendChild(viewInline);
      row.appendChild(info);

      var aside = document.createElement('div');
      aside.className = 'pdp-v2__pvos-aside';
      var changeTop = document.createElement('button');
      changeTop.type = 'button';
      changeTop.className = 'pdp-v2__preview-bar-change pdp-v2__pvos-change';
      changeTop.setAttribute('data-pdp-v2-change-colour', '');
      changeTop.textContent = 'Change colour';
      var viewAside = document.createElement('button');
      viewAside.type = 'button';
      viewAside.className = 'pdp-v2__pvos-view pdp-v2__pvos-view--aside';
      viewAside.setAttribute('data-pdp-v2-preview-view', '');
      viewAside.innerHTML = viewIcon + '<span>View full image →</span>';
      aside.appendChild(changeTop);
      aside.appendChild(viewAside);
      row.appendChild(aside);
      pvos.appendChild(row);

      var divider = document.createElement('div');
      divider.className = 'pdp-v2__pvos-divider';
      pvos.appendChild(divider);

      var swBlock = document.createElement('div');
      swBlock.className = 'pdp-v2__pvos-swatches';
      var swLabel = document.createElement('div');
      swLabel.className = 'pdp-v2__pvos-swatches-label';
      swLabel.textContent = this._colors.length + ' colours — tap to switch';
      var swRow = document.createElement('div');
      swRow.className = 'pdp-v2__pvos-swatch-row';
      swRow.setAttribute('data-pdp-v2-swatch-row', '');
      swBlock.appendChild(swLabel);
      swBlock.appendChild(swRow);
      pvos.appendChild(swBlock);

      // Mobile-only full-width copy beneath the strip (aside copy hides there).
      var changeBottom = document.createElement('button');
      changeBottom.type = 'button';
      changeBottom.className = 'pdp-v2__preview-bar-change pdp-v2__pvos-change pdp-v2__pvos-change--bottom';
      changeBottom.setAttribute('data-pdp-v2-change-colour', '');
      changeBottom.textContent = 'Change colour';
      pvos.appendChild(changeBottom);

      var self = this;
      var lastMeasuredW = 0;
      function renderStrip() {
        lastMeasuredW = swRow.clientWidth;
        self._renderSwatchStrip(swRow);
        // Operator ruling 2026-09-02 (reverses the 2026-09-01 fit-decides
        // behaviour): "Change colour" renders on EVERY product regardless of
        // colour count — the drawer shows names and stock the small swatches
        // don't, and an always-present control is easier to learn. The strip,
        // the "+N more" chip and the popularity ordering are untouched.
        // Single-colour products keep the button hidden (nothing to change
        // to) — provisional call, flagged for the operator.
        var single = self._colors.length <= 1;
        changeTop.hidden = single;
        changeBottom.hidden = single;
      }
      renderStrip();
      // The first render can run before the desktop two-column layout settles,
      // under-measuring the row. Re-check after layout and once more shortly
      // after (reveal transitions); re-render only if the width actually moved.
      function remeasure() {
        if (swRow.isConnected && Math.abs(swRow.clientWidth - lastMeasuredW) > SWATCH_SIZE_PX) renderStrip();
      }
      if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(remeasure);
      setTimeout(remeasure, 300);
      if (this._colors.length <= 1) { swBlock.hidden = true; divider.hidden = true; }
    }

    // Capacity falls out of the container width — measured, not hardcoded.
    // Overflow colours are NOT rendered at all: nothing behind the "+N more"
    // chip may load an image until the colour picker itself opens.
    _renderSwatchStrip(swRow) {
      var self = this;
      var colors = this._colors || [];
      swRow.innerHTML = '';
      var SW = SWATCH_SIZE_PX, GAP = SWATCH_GAP_PX;
      var w = swRow.clientWidth || (swRow.parentElement && swRow.parentElement.clientWidth) || this.clientWidth || 343;
      // clientWidth includes the row's ring padding — measure the usable box.
      try {
        var rcs = getComputedStyle(swRow);
        w -= (parseFloat(rcs.paddingLeft) || 0) + (parseFloat(rcs.paddingRight) || 0);
      } catch (e) { /* keep unadjusted width */ }
      var capacity = Math.max(1, Math.floor((w + GAP) / (SW + GAP)));
      var needChip = colors.length > capacity;
      var visCount = colors.length;
      if (needChip) {
        // The chip is wider than a swatch: estimate its width from its label
        // ("+NN more") and reserve whole slots for it.
        var hiddenGuess = Math.max(1, colors.length - (capacity - 2));
        var chipW = 24 + (('+' + hiddenGuess + ' more').length * 6.5);
        var chipSlots = Math.max(1, Math.ceil((chipW + GAP) / (SW + GAP)));
        visCount = Math.max(1, capacity - chipSlots);
      }
      var visible = colors.slice(0, visCount);
      var selName = this._state.selectedColor && this._state.selectedColor.name;
      var selIdx = -1;
      for (var i = 0; i < colors.length; i++) {
        if (selName && colors[i].name === selName) { selIdx = i; break; }
      }
      // The selected ring must always be on screen: a colour picked from the
      // drawer that sits past the cut takes the last visible slot.
      if (selIdx >= visCount && visible.length) visible[visible.length - 1] = colors[selIdx];
      visible.forEach(function(c) { swRow.appendChild(self._createStripSwatch(c)); });
      if (needChip) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'pdp-v2__pvos-chip';
        chip.setAttribute('data-pdp-v2-change-colour', '');
        chip.setAttribute('aria-label', 'Show all ' + colors.length + ' colours');
        chip.textContent = '+' + (colors.length - visible.length) + ' more';
        swRow.appendChild(chip);
        // The chip width was estimated; measure the real row and shed swatches
        // until everything genuinely fits — exact regardless of fonts. The
        // selected swatch is never the one shed.
        var guard = 0;
        while (swRow.scrollWidth > swRow.clientWidth + 1 && guard++ < 10) {
          var swEls = swRow.querySelectorAll('.pdp-v2__pvos-swatch');
          if (swEls.length <= 1) break;
          var last = swEls[swEls.length - 1];
          var toRemove = (last.classList.contains('pdp-v2__pvos-swatch--selected') && swEls.length >= 2)
            ? swEls[swEls.length - 2] : last;
          toRemove.remove();
          chip.textContent = '+' + (colors.length - swRow.querySelectorAll('.pdp-v2__pvos-swatch').length) + ' more';
        }
      }
      return needChip;
    }

    // Real product-image swatch (operator ruling 2026-09-01 — not solid
    // colours). Fallback chain: product image → hex → neutral. Never empty.
    _createStripSwatch(c) {
      var self = this;
      var sel = this._state.selectedColor && this._state.selectedColor.name === c.name;
      // Same known-zero rule as the grid pills (one source, _getSizesForColor):
      // a colour unclickable in the grid must not be clickable here — the tap
      // reaches the same dead end. Unknown stock stays selectable.
      var soldOut = false;
      try {
        var stripSizes = this._getSizesForColor(c.name);
        soldOut = stripSizes.length === 1 && stripSizes[0].stockKnown && stripSizes[0].stock === 0;
      } catch (e) {}
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdp-v2__pvos-swatch' + (sel ? ' pdp-v2__pvos-swatch--selected' : '') + (soldOut ? ' pdp-v2__pvos-swatch--soldout' : '');
      b.title = soldOut ? c.name + ' — out of stock' : c.name;
      b.setAttribute('aria-label', soldOut ? c.name + ', out of stock' : 'Switch to ' + c.name);
      b.setAttribute('aria-pressed', sel ? 'true' : 'false');
      if (soldOut) b.disabled = true;
      if (c.image && c.image.trim()) {
        var img = document.createElement('img');
        img.src = this._sizedImageUrl(c.image, 68);
        img.alt = '';
        img.loading = sel ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.width = SWATCH_SIZE_PX;
        img.height = SWATCH_SIZE_PX;
        img.onerror = function() { img.remove(); b.style.background = c.hex || '#E5E5E5'; if (!c.hex || isLightColor(c.hex)) b.classList.add('pdp-v2__pvos-swatch--light'); };
        b.appendChild(img);
      } else if (c.hex) {
        b.style.background = c.hex;
        if (isLightColor(c.hex)) b.classList.add('pdp-v2__pvos-swatch--light');
      } else {
        b.style.background = '#E5E5E5';
        b.classList.add('pdp-v2__pvos-swatch--light');
      }
      // Same code path as the drawer and colour-grid pills — no parallel one.
      if (!sel && !soldOut) b.addEventListener('click', function() { self._selectColor(c); });
      return b;
    }

    _createColorPill(color) {
      var self = this;
      var selected = this._state.selectedColor && this._state.selectedColor.name === color.name;
      var light = isLightColor(color.hex);
      var pill = document.createElement('div');
      pill.className = 'pdp-v2__pill' + (selected ? ' pdp-v2__pill--selected' : '');
      pill.setAttribute('role', 'listitem');
      var swatchSpan = document.createElement('span');
      var useImageSwatch = color.image && color.image.trim();
      swatchSpan.className = 'pdp-v2__pill-swatch' + (light && !useImageSwatch ? ' pdp-v2__pill-swatch--light' : '') + (useImageSwatch ? ' pdp-v2__pill-swatch--image' : '');
      if (useImageSwatch) {
        swatchSpan.style.backgroundImage = 'url(' + color.image + ')';
        swatchSpan.style.backgroundSize = 'cover';
        swatchSpan.style.backgroundPosition = 'center';
      } else {
        swatchSpan.style.background = color.hex;
      }
      if (selected) {
        var check = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        check.setAttribute('width', '10');
        check.setAttribute('height', '8');
        check.setAttribute('viewBox', '0 0 12 9');
        check.setAttribute('fill', 'none');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M1 4.5L4.5 8L11 1');
        path.setAttribute('stroke', light ? '#ea580c' : '#fff');
        path.setAttribute('stroke-width', '2');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');
        check.appendChild(path);
        swatchSpan.appendChild(check);
      }
      var nameSpan = document.createElement('span');
      nameSpan.className = 'pdp-v2__pill-name';
      nameSpan.textContent = color.name;
      // Per-colour stock (operator ruling 2026-09-01) — ONE-SIZE colours only:
      // on multi-size a single number sums across sizes and misleads. The test
      // is per-colour size-value count (never the label), and the figure comes
      // from the SAME _getSizesForColor read the quantity block renders — one
      // stock source, or the two surfaces disagree the first time it changes.
      // Zero/unknown stock → no line (a "0 in stock" selectable pill needs the
      // disable-or-hide ruling, which is its own task). Plain muted text, no
      // urgency treatment (ruled).
      var stockLine = null;
      var soldOut = false;
      try {
        var pillSizes = this._getSizesForColor(color.name);
        if (pillSizes.length === 1 && pillSizes[0].stockKnown) {
          // Known-zero disables (operator ruling 2026-09-01: disable, don't
          // hide). UNKNOWN stock (stockKnown false, the 999 fallback) stays
          // fully selectable with no figure — blocking a sale on an assumption
          // is worse than the dead end this fixes.
          if (pillSizes[0].stock > 0) stockLine = pillSizes[0].stock + ' in stock';
          else soldOut = true;
        }
      } catch (e) {}
      if (soldOut) stockLine = 'Out of stock'; // replaces the figure, never alongside it
      var wrap = document.createElement('button');
      wrap.type = 'button';
      wrap.setAttribute('aria-label', soldOut
        ? color.name + ', out of stock'
        : 'Select ' + color.name + (stockLine ? ', ' + stockLine : ''));
      wrap.className = 'pdp-v2__pill';
      if (selected) wrap.classList.add('pdp-v2__pill--selected');
      if (soldOut) {
        wrap.classList.add('pdp-v2__pill--soldout');
        wrap.disabled = true; // real disabled: unclickable AND out of tab order
      }
      wrap.style.background = selected ? 'var(--jrs-orange-light)' : 'var(--jrs-white)';
      wrap.appendChild(swatchSpan);
      if (stockLine) {
        // Text column only when a stock line renders — pills without one keep
        // today's exact structure (multi-size stays byte-identical).
        var textWrap = document.createElement('span');
        textWrap.className = 'pdp-v2__pill-text';
        var stockSpan = document.createElement('span');
        stockSpan.className = 'pdp-v2__pill-stock' + (soldOut ? ' pdp-v2__pill-stock--oos' : '');
        stockSpan.textContent = stockLine;
        textWrap.appendChild(nameSpan);
        textWrap.appendChild(stockSpan);
        wrap.appendChild(textWrap);
      } else {
        wrap.appendChild(nameSpan);
      }
      if (!soldOut) {
        wrap.addEventListener('click', function() {
          self._selectColor(color);
        });
      }
      pill.appendChild(wrap);
      return pill;
    }

    _selectColor(color) {
      this._state.selectedColor = color;
      // New colour → new size set: always collapse the preview-bar size list
      // so the summary starts predictable (2026-08-31).
      this._state.previewSizesExpanded = false;
      this._renderStep1();
      // Inline single-screen flow: reveal the size grid immediately — no
      // "Continue to Size Selection" click. The colour grid stays visible above.
      this._revealSizesInline();
      this._track('color_selected', { colorName: color.name, step: 1 });
      var self = this;
      if (typeof requestAnimationFrame !== 'undefined') {
        requestAnimationFrame(function () {
          self._syncGalleryToColor(color);
          // Gallery sync can shift page Y; correct once after it settles.
          setTimeout(function() {
            self._scrollToFormWithHeaderOffset({ force: true, behavior: 'auto' });
          }, 120);
        });
      } else {
        setTimeout(function () {
          self._syncGalleryToColor(color);
          setTimeout(function() {
            self._scrollToFormWithHeaderOffset({ force: true, behavior: 'auto' });
          }, 120);
        }, 0);
      }
    }

    _syncGalleryToColor(color, retry) {
      var colorName = (color && color.name) ? String(color.name).trim() : '';
      if (!colorName) return;

      var pairs = window.JRS_COLOR_GALLERY_PAIRS;
      if (!Array.isArray(pairs) || pairs.length === 0) return;

      var colorToIndex = {};
      for (var i = 0; i < pairs.length; i++) {
        var p = pairs[i];
        if (p && p[1] != null) colorToIndex[p[1]] = p[0];
      }
      var index = colorToIndex[colorName];
      if (index == null) index = colorToIndex[colorName.toLowerCase()];
      if (index == null && colorName.toLowerCase) {
        var keys = Object.keys(colorToIndex);
        for (var k = 0; k < keys.length; k++) {
          if (keys[k].toLowerCase() === colorName.toLowerCase()) {
            index = colorToIndex[keys[k]];
            break;
          }
        }
      }
      if (index == null || index < 0) return;

      var galleryEl = document.querySelector('#product-gallery-main-product-steps-gallery');
      if (!galleryEl) return;
      if (!galleryEl._productGallery) {
        if (retry !== true) {
          var self = this;
          setTimeout(function () { self._syncGalleryToColor(color, true); }, 150);
        }
        return;
      }
      var goTo = galleryEl._productGallery.goTo;
      if (typeof goTo === 'function') {
        goTo.call(galleryEl._productGallery, index);
      }
    }

    _updateContinueButton() {
      var btn = this.querySelector('[data-pdp-v2-continue]');
      var helper = this.querySelector('[data-pdp-v2-helper-disabled]');
      if (!btn) return;
      var enabled = !!this._state.selectedColor;
      btn.disabled = !enabled;
      btn.style.background = enabled ? 'var(--jrs-green)' : 'var(--jrs-border)';
      btn.style.cursor = enabled ? 'pointer' : 'default';
      if (helper) helper.hidden = enabled;
    }

    _bindStep1() {
      var self = this;
      var btn = this.querySelector('[data-pdp-v2-continue]');
      if (btn) btn.addEventListener('click', function() { self._goStep2(); });
    }

    // skipScroll: true when advanced automatically on load (single-colour
    // product) — a forced scroll on page load would be jarring; the user didn't
    // click anything. Otherwise (a real "Continue" click) scroll the sizes into
    // view as before.
    _goStep2(skipScroll) {
      if (!this._state.selectedColor) return;
      this._state.step = 2;
      this.setAttribute('data-current-step', '2');
      this.querySelector('[data-pdp-v2-step="1"]').hidden = true;
      var step2 = this.querySelector('[data-pdp-v2-step="2"]');
      step2.hidden = false;
      this._renderStep2();
      this._renderProgress();
      this._renderStickyFooter();
      if (!skipScroll) this._scrollToMountWithHeaderOffset();
      this._track('step_completed', { step: 1, auto: !!skipScroll });
    }

    // Inline mode: reveal Step 2's size grid WITHOUT hiding Step 1 (colours stay
    // visible above). Reuses all of Step 2's rendering — sizes, ATC, sticky
    // footer; only the redundant colour summary + the obsolete Continue button
    // are suppressed. Called from _selectColor so a colour tap shows sizes with
    // no "Continue to Size Selection" click. Re-tapping a colour re-renders the
    // sizes for the new colour in place. No scroll jump — the sizes are right
    // beneath the colour grid.
    _revealSizesInline() {
      if (!this._state.selectedColor) return;
      this._state.step = 2; // keep Step-2 semantics for ATC / sticky footer / progress
      this.setAttribute('data-current-step', '2');
      var step1 = this.querySelector('[data-pdp-v2-step="1"]');
      if (step1) step1.hidden = true;             // colours hide — the preview bar (now inside Step 2) is the colour summary
      var step2 = this.querySelector('[data-pdp-v2-step="2"]');
      if (step2) step2.hidden = false;            // size box appears, with the preview bar at its top
      var summaryCard = this.querySelector('.pdp-v2__color-summary-card');
      if (summaryCard) summaryCard.hidden = true; // redundant — the rich preview bar shows the colour
      var cont = this.querySelector('[data-pdp-v2-continue]');
      if (cont) cont.hidden = true;               // no longer needed
      var helper = this.querySelector('[data-pdp-v2-helper-disabled]');
      if (helper) helper.hidden = true;
      this._renderStep2();
      this._renderProgress();
      this._renderStickyFooter();
    }

    // Collapse/expand the colour grid + its heading + show-more. Collapsed leaves
    // only the preview bar visible in Step 1 (the compact selected-colour summary).
    _setColourGridCollapsed(collapsed) {
      var step1 = this.querySelector('[data-pdp-v2-step="1"]');
      if (!step1) return;
      var grid = step1.querySelector('[data-pdp-v2-color-grid]');
      var heading = step1.querySelector('.pdp-v2__heading');
      if (grid) grid.hidden = collapsed;
      if (heading) heading.hidden = collapsed;
      if (collapsed) {
        var showMore = step1.querySelector('[data-pdp-v2-show-more]');
        if (showMore) showMore.hidden = true; // on expand, _renderStep1 restores it by count
      }
      // Strip the Step-1 card chrome when collapsed so the preview bar reads as the
      // top of the sizes, not a detached orange-bordered card (see the CSS rule).
      var card = step1.querySelector('.pdp-v2__card');
      if (card) {
        if (collapsed) card.setAttribute('data-pdp-v2-colour-collapsed', '');
        else card.removeAttribute('data-pdp-v2-colour-collapsed');
      }
      this._state.colourGridCollapsed = collapsed;
    }

    _scrollToMountWithHeaderOffset() {
      var mount = document.getElementById('pdp-v2-mount');
      if (!mount) return;
      var headerSection = document.querySelector('#shopify-section-jrs-main-header') || document.querySelector('.jrs-main-header');
      var headerHeight = (headerSection && headerSection.offsetHeight) ? headerSection.offsetHeight : 100;
      var spacing = 12;
      var offset = headerHeight + spacing;
      var top = mount.getBoundingClientRect().top + (window.pageYOffset || window.scrollY) - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    _scrollToFormWithHeaderOffset(options) {
      options = options || {};
      var mount = document.getElementById('pdp-v2-mount') || this;
      var headerSection = document.querySelector('#shopify-section-jrs-main-header') || document.querySelector('.jrs-main-header');
      var headerHeight = (headerSection && headerSection.offsetHeight) ? headerSection.offsetHeight : 100;
      var spacing = 12;
      var offset = headerHeight + spacing;
      var desiredTop = function() {
        return Math.max(0, mount.getBoundingClientRect().top + (window.pageYOffset || window.scrollY) - offset);
      };

      var targetTop = desiredTop();
      var currentY = window.pageYOffset || window.scrollY || 0;
      // Avoid re-scrolling when we're already aligned; this prevents bounce/jump loops.
      if (!options.force && Math.abs(currentY - targetTop) <= 4) return;
      window.scrollTo({ top: targetTop, behavior: options.behavior || 'smooth' });
    }

    /**
     * Public API — reset the form to its pristine post-init state (step 1,
     * no colour, no quantities) WITHOUT a page reload. Called by the
     * customiser success step's "Continue shopping" CTA after the purchased
     * configuration is committed to the cart. Returns true when the reset
     * ran; false (form not initialised) tells the caller to fall back to a
     * full reload. Mirrors _goStep1's DOM restoration plus the single-colour
     * auto-advance from _initAfterVariants.
     */
    reset() {
      if (this.getAttribute('data-pdp-v2-ready') !== 'true') return false;
      this._state.step = 1;
      this._state.selectedColor = null;
      this._state.quantities = {};
      this._state.drawerOpen = false;
      this._state.previewColor = null;
      this._closeDrawer();
      this._closePreview();
      var step1 = this.querySelector('[data-pdp-v2-step="1"]');
      var step2 = this.querySelector('[data-pdp-v2-step="2"]');
      if (step1) step1.hidden = false;
      if (step2) step2.hidden = true;
      this.setAttribute('data-current-step', '1');
      this._setColourGridCollapsed(false);
      this._renderStep1();
      var bar = this.querySelector('[data-pdp-v2-preview-bar]');
      if (bar) bar.hidden = true;
      this._renderProgress();
      var sticky = this.querySelector('[data-pdp-v2-sticky-footer]');
      if (sticky) sticky.hidden = true;
      // Single-colour products skip the colour step on init — mirror that
      // here so the reset lands on the size grid with empty quantities.
      if (this._colors.length === 1) {
        this._state.selectedColor = this._colors[0];
        this._goStep2(true);
      }
      this._track('form_reset', { source: 'continue_shopping' });
      return true;
    }

    _goStep1() {
      this._state.step = 1;
      this.setAttribute('data-current-step', '1');
      this.querySelector('[data-pdp-v2-step="1"]').hidden = false;
      this.querySelector('[data-pdp-v2-step="2"]').hidden = true;
      // Re-expand the colour grid so the customer can pick a different colour.
      this._setColourGridCollapsed(false);
      this._renderStep1();
      // Hide the collapsed preview bar while choosing (renderStep1 un-hid it).
      var bar = this.querySelector('[data-pdp-v2-preview-bar]');
      if (bar) bar.hidden = true;
      this._renderProgress();
      this.querySelector('[data-pdp-v2-sticky-footer]').hidden = true;
      this._track('step_back', { fromStep: 2 });
    }

    _renderStep2() {
      var summary = this.querySelector('[data-pdp-v2-color-summary]');
      var sizes = this._getSizesForColor(this._state.selectedColor.name);
      var self = this;
      if (!this._state.quantities[this._state.selectedColor.name]) {
        this._state.quantities[this._state.selectedColor.name] = {};
      }
      var qtyMap = this._state.quantities[this._state.selectedColor.name];

      if (summary) {
        summary.innerHTML = '';
        var left = document.createElement('div');
        left.className = 'pdp-v2__color-summary-left';
        var checkSvg = '<svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#16a34a"/><path d="M4.5 8.5L7 11L11.5 5.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        left.innerHTML = checkSvg + ' <span style="font-size:13px;font-weight:600">Colour:</span> ';
        var swatch = document.createElement('span');
        swatch.className = 'pdp-v2__color-summary-swatch';
        var imgUrl = (this._state.selectedColor.image && this._state.selectedColor.image.trim()) ||
          (this._data && (this._data.mainProductImage || this._data.main_product_image)) ||
          (this._colors && this._colors[0] && this._colors[0].image && this._colors[0].image.trim()) ||
          '';
        imgUrl = typeof imgUrl === 'string' ? imgUrl.trim() : '';
        if (imgUrl) {
          swatch.classList.add('pdp-v2__color-summary-swatch--image');
          swatch.style.backgroundImage = 'url("' + String(imgUrl).replace(/\\/g, '\\\\').replace(/"/g, '\\22') + '")';
          swatch.style.backgroundSize = 'cover';
          swatch.style.backgroundPosition = 'center';
          swatch.style.backgroundColor = 'transparent';
          swatch.style.border = '1px solid var(--jrs-border)';
        } else {
          swatch.style.background = this._state.selectedColor.hex;
          if (isLightColor(this._state.selectedColor.hex)) swatch.style.border = '1px solid var(--jrs-border)';
        }
        left.appendChild(swatch);
        left.appendChild(document.createTextNode(' '));
        var nameSpan = document.createElement('span');
        nameSpan.style.fontSize = '13px';
        nameSpan.style.fontWeight = '700';
        nameSpan.textContent = this._state.selectedColor.name;
        left.appendChild(nameSpan);
        var viewLink = document.createElement('button');
        viewLink.type = 'button';
        viewLink.className = 'pdp-v2__color-summary-change';
        viewLink.style.fontSize = '11px';
        viewLink.style.marginLeft = '6px';
        viewLink.textContent = 'View Image';
        viewLink.addEventListener('click', function() { self._openPreview(self._state.selectedColor); });
        left.appendChild(viewLink);
        summary.appendChild(left);
        // "Change" (back to the colour grid) only makes sense with >1 colour.
        // Single-colour products auto-advance past the colour step, so there's
        // nothing to change — omit the button.
        if (this._colors.length > 1) {
          var changeBtn = document.createElement('button');
          changeBtn.type = 'button';
          changeBtn.className = 'pdp-v2__color-summary-change';
          changeBtn.textContent = 'Change';
          changeBtn.addEventListener('click', function() { self._goStep1(); });
          summary.appendChild(changeBtn);
        }
      }

      // One-size path (2026-08-31): quantity defaults to 1 (operator-ruled
      // behaviour change — the CTA is live on arrival), the inline discount
      // ramp is dropped (the tier boxes carry it), and the size-grid hint is
      // hidden. Multi-size products are untouched.
      var isOneSize = sizes.length === 1;
      if (isOneSize && sizes[0].stock !== 0 && !(qtyMap[sizes[0].label] > 0)) {
        qtyMap[sizes[0].label] = 1;
      }
      var oneSizeHelper = this.querySelector('[data-pdp-v2-helper-qty]');
      if (oneSizeHelper && isOneSize) oneSizeHelper.hidden = true;
      // Card heading matches the choice on offer (operator ruling 2026-08-31):
      // one size → "Select quantity". Restored explicitly for multi-size in
      // case a colour switch flips the mode.
      var cardHeading = this.querySelector('.pdp-v2__size-card-head .pdp-v2__heading');
      if (cardHeading) cardHeading.textContent = isOneSize ? 'Select quantity' : 'Select Sizes & Quantities';
      // Ramp + size-guide gating lives inside the render helpers so every
      // update path (e.g. _updateQty calls _renderDiscountBar directly) stays
      // consistent — the ramp must not resurrect after a quantity change.
      this._renderDiscountBar();
      this._syncSizeGuideVisibility();
      var grid = this.querySelector('[data-pdp-v2-size-grid]');
      if (isOneSize && grid) {
        this._renderOneSizeCard(grid, sizes[0], qtyMap);
        var oneSizeShowMore = this.querySelector('[data-pdp-v2-size-show-more]');
        if (oneSizeShowMore) { oneSizeShowMore.hidden = true; oneSizeShowMore.innerHTML = ''; }
        this._renderRunningTotal();
        this._updateAtcButton();
        this._notifyVolumeDrawer();
        return;
      }
      if (grid) grid.classList.remove('pdp-v2__size-grid--onesize');
      // Collapse long size lists to the first SIZE_LIMIT, with a "Show all
      // sizes" toggle (mirrors the colour grid's show-more). Expansion persists
      // across re-renders (_state.sizesExpanded) and auto-opens when a selected
      // size sits past the cap (e.g. a resumed draft) so a picked size is never
      // hidden. Products with <= SIZE_LIMIT sizes render fully, no button.
      var SIZE_LIMIT = 15;
      var deepSelection = sizes.some(function(s, i) { return i >= SIZE_LIMIT && (qtyMap[s.label] || 0) > 0; });
      if (deepSelection) this._state.sizesExpanded = true;
      var sizesExpanded = !!this._state.sizesExpanded || sizes.length <= SIZE_LIMIT;
      if (grid) {
        grid.innerHTML = '';
        var visibleSizes = sizesExpanded ? sizes : sizes.slice(0, SIZE_LIMIT);
        visibleSizes.forEach(function(s) {
          var cell = self._createSizeCell(s, qtyMap[s.label] || 0);
          grid.appendChild(cell);
        });
      }
      var sizeShowMore = this.querySelector('[data-pdp-v2-size-show-more]');
      if (sizeShowMore) {
        if (sizes.length > SIZE_LIMIT) {
          sizeShowMore.hidden = false;
          sizeShowMore.innerHTML = sizesExpanded
            ? '<button type="button" class="pdp-v2__show-more-btn" data-pdp-v2-size-toggle="collapse">Show fewer ↑</button>'
            : '<button type="button" class="pdp-v2__show-more-btn" data-pdp-v2-size-toggle="expand">Show all ' + sizes.length + ' sizes ↓</button>';
          var sizeToggleBtn = sizeShowMore.querySelector('[data-pdp-v2-size-toggle]');
          if (sizeToggleBtn) {
            sizeToggleBtn.addEventListener('click', function() {
              self._state.sizesExpanded = sizeToggleBtn.getAttribute('data-pdp-v2-size-toggle') === 'expand';
              self._renderStep2();
            });
          }
        } else {
          sizeShowMore.hidden = true;
          sizeShowMore.innerHTML = '';
        }
      }
      this._renderRunningTotal();
      this._updateAtcButton();
      this._notifyVolumeDrawer();
    }

    _createSizeCell(size, qty) {
      var self = this;
      var active = qty > 0;
      var soldOut = size.stock === 0;
      var low = size.stock > 0 && size.stock <= 10;
      var cell = document.createElement('div');
      cell.className = 'pdp-v2__size-cell' + (active ? ' pdp-v2__size-cell--active' : '') + (soldOut ? ' pdp-v2__size-cell--soldout' : '');
      if (size.popular && !soldOut) {
        var pop = document.createElement('div');
        pop.className = 'pdp-v2__size-cell__popular';
        pop.textContent = 'Popular';
        cell.appendChild(pop);
      }
      var label = document.createElement('div');
      label.className = 'pdp-v2__size-cell__label';
      label.textContent = size.label;
      cell.appendChild(label);
      var priceEl = document.createElement('div');
      priceEl.className = 'pdp-v2__size-cell__price';
      priceEl.textContent = '\u00a3' + size.price.toFixed(2);
      cell.appendChild(priceEl);
      var invEl = document.createElement('div');
      invEl.className = 'pdp-v2__size-cell__inventory';
      if (size.stock === 0) {
        invEl.textContent = 'Out of stock';
      } else if (size.stockKnown) {
        invEl.appendChild(document.createTextNode('Stock: '));
        var numSpan = document.createElement('span');
        numSpan.className = 'pdp-v2__size-cell__inventory-num';
        numSpan.textContent = String(size.stock);
        invEl.appendChild(numSpan);
      } else {
        invEl.textContent = 'In stock';
      }
      cell.appendChild(invEl);
      var qtyRow = document.createElement('div');
      qtyRow.className = 'pdp-v2__size-cell__qty-row';
      var minusBtn = document.createElement('button');
      minusBtn.type = 'button';
      minusBtn.className = 'pdp-v2__size-cell__btn';
      minusBtn.setAttribute('aria-label', 'Decrease ' + size.label);
      minusBtn.textContent = '\u2212';
      minusBtn.disabled = soldOut || qty <= 0;
      minusBtn.addEventListener('click', function() {
        if (soldOut || qty <= 0) return;
        self._updateQty(size.label, Math.max(0, qty - 1));
      });
      var qtyDisplay = document.createElement('span');
      qtyDisplay.className = 'pdp-v2__size-cell__qty-display' + (active ? ' pdp-v2__size-cell__qty-display--has-qty' : '');
      qtyDisplay.textContent = qty;
      qtyDisplay.dataset.sizeLabel = size.label;
      if (!soldOut) {
        qtyDisplay.addEventListener('click', function() {
          self._startDirectInput(size.label);
        });
      }
      var plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.className = 'pdp-v2__size-cell__btn';
      plusBtn.setAttribute('aria-label', 'Increase ' + size.label);
      plusBtn.textContent = '+';
      plusBtn.disabled = soldOut || qty >= size.stock;
      plusBtn.addEventListener('click', function() {
        if (soldOut || qty >= size.stock) return;
        self._updateQty(size.label, Math.min(size.stock, qty + 1));
      });
      qtyRow.appendChild(minusBtn);
      qtyRow.appendChild(qtyDisplay);
      qtyRow.appendChild(plusBtn);
      cell.appendChild(qtyRow);
      if (active) {
        var sub = document.createElement('div');
        sub.className = 'pdp-v2__size-cell__subtotal';
        sub.textContent = '\u00a3' + (qty * size.price).toFixed(2);
        cell.appendChild(sub);
      }
      if (low && !active && !soldOut) {
        var stockWarn = document.createElement('div');
        stockWarn.className = 'pdp-v2__size-cell__stock';
        stockWarn.textContent = 'Only ' + size.stock + ' left';
        cell.appendChild(stockWarn);
      } else if (low && active) {
        var stockWarn2 = document.createElement('div');
        stockWarn2.className = 'pdp-v2__size-cell__stock';
        stockWarn2.textContent = (size.stock - qty) + ' left';
        cell.appendChild(stockWarn2);
      } else if (soldOut) {
        var sold = document.createElement('div');
        sold.className = 'pdp-v2__size-cell__soldout';
        sold.textContent = 'Sold out';
        cell.appendChild(sold);
      }
      return cell;
    }

    _updateQty(label, value) {
      var colorName = this._state.selectedColor && this._state.selectedColor.name;
      if (!colorName) return;
      if (!this._state.quantities[colorName]) this._state.quantities[colorName] = {};
      var prev = this._state.quantities[colorName][label] || 0;
      this._state.quantities[colorName][label] = value;
      this._renderStep2();
      this._renderDiscountBar();
      this._renderRunningTotal();
      this._updateAtcButton();
      this._renderStickyFooter();
      this._renderProgress();
      this._notifyVolumeDrawer();
      this._track('size_qty_changed', { sizeLabel: label, oldQty: prev, newQty: value });
    }

    _notifyVolumeDrawer() {
      var tot = this._calcTotal();
      if (typeof window.cvdUpdateProgress === 'function') {
        window.cvdUpdateProgress(tot.totalQty);
      }
      if (typeof window.cvdUpdateExplorer === 'function') {
        window.cvdUpdateExplorer(tot.totalQty);
      }
    }

    _startDirectInput(label) {
      var display = this.querySelector('.pdp-v2__size-cell__qty-display[data-size-label="' + label + '"]');
      if (!display) return;
      var self = this;
      var sizes = this._getSizesForColor(this._state.selectedColor.name);
      var size = sizes.find(function(s) { return s.label === label; });
      if (!size || size.stock === 0) return;
      var qty = this._state.quantities[this._state.selectedColor.name] && this._state.quantities[this._state.selectedColor.name][label] || 0;
      var input = document.createElement('input');
      input.type = 'number';
      input.min = 0;
      input.max = size.stock;
      input.value = qty;
      input.className = 'pdp-v2__size-cell__qty-display pdp-v2__size-cell__qty-input';
      input.style.width = '44px';
      input.style.minWidth = '44px';
      input.style.padding = '8px 6px';
      input.style.border = '1px solid var(--jrs-orange)';
      input.style.borderRadius = '6px';
      input.style.fontSize = '15px';
      input.style.fontWeight = '600';
      input.style.color = 'var(--jrs-orange)';
      input.style.textAlign = 'center';
      input.style.boxSizing = 'border-box';
      // One-size stepper is the primary control at 48px — size the swapped-in
      // input to match it, not the compact grid-cell dimensions.
      if (display.closest('.pdp-v2__onesize-stepper')) {
        input.style.width = '88px';
        input.style.minWidth = '88px';
        input.style.height = '48px';
        input.style.fontSize = '20px';
        input.style.fontWeight = '700';
      }
      input.dataset.sizeLabel = label;
      input.addEventListener('change', function() {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        if (v > size.stock) v = size.stock;
        self._updateQty(label, v);
        self._track('direct_input_used', { sizeLabel: label });
      });
      input.addEventListener('blur', function() {
        // Blur with a change re-renders the grid via _updateQty; blur WITHOUT
        // a change must put the display span back (it was swapped out via
        // replaceChild) or the stepper is left as bare −/+ buttons.
        var q = self._state.quantities[self._state.selectedColor.name] && self._state.quantities[self._state.selectedColor.name][label] || 0;
        display.textContent = q;
        display.hidden = false;
        if (input.parentNode) input.parentNode.replaceChild(display, input);
        else input.remove();
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') input.blur();
      });
      display.parentNode.replaceChild(input, display);
      input.focus();
      input.select();
    }

    // One tier source (2026-08-31): the Volume Pricing drawer's rendered table
    // (#cvdTable-garment, from the volume-discount-drawer section's tier
    // blocks) is the authority — the same DOM the preview bar already prefers.
    // Fallback chain matches the existing pattern: bootstrap discountTiers,
    // then the legacy constant. Never a second tier table.
    _getTiers() {
      if (!this._isVolumeEligible()) { this._tiersCache = []; return this._tiersCache; }
      if (this._tiersCache) return this._tiersCache;
      var parsed = [];
      var table = document.getElementById('cvdTable-garment');
      if (table) {
        var rows = table.querySelectorAll('.cvd-table-row[data-min]');
        rows.forEach(function(row) {
          var min = parseInt(row.getAttribute('data-min'), 10);
          if (isNaN(min)) return;
          var discEl = row.querySelector('.cvd-table-discount:not(.none)');
          var disc = discEl ? parseInt(discEl.textContent, 10) || 0 : 0;
          parsed.push({ minQty: min, discount: disc, label: disc > 0 ? disc + '% off' : '—' });
        });
      }
      this._tiersCache = parsed.length ? parsed : (this._data.discountTiers || GARMENT_DISCOUNT_TIERS);
      return this._tiersCache;
    }

    // One-size products (size option has exactly one value for the selected
    // colour): the size grid is replaced by a quantity row + stock-aware
    // quick-quantity tier boxes (operator design, 2026-08-31). Boxes render
    // only for tiers reachable with the colour's available stock — an
    // unreachable discount tier is an unreachable claim. Quantity flows
    // through the same _updateQty path as the grid; no flow changes.
    _renderOneSizeCard(grid, size, qtyMap) {
      var self = this;
      var qty = qtyMap[size.label] || 0;
      var stock = size.stockKnown ? size.stock : Number.MAX_SAFE_INTEGER;
      var tiers = this._getTiers().filter(function(t) { return t.discount > 0; });
      // Every reachable tier renders (operator ruling 2026-08-31): the only
      // filter is reachability — minQty <= stock. An unreachable tier is an
      // unreachable claim and stays hidden. Boxes wrap at narrow widths.
      var reachableAll = tiers.filter(function(t) { return t.minQty <= stock; });
      var reachable = reachableAll;

      grid.innerHTML = '';
      grid.classList.add('pdp-v2__size-grid--onesize');

      // 1. Quantity row
      var row = document.createElement('div');
      row.className = 'pdp-v2__onesize-row';
      var info = document.createElement('div');
      info.className = 'pdp-v2__onesize-info';
      // No inner title: the card heading ("Select quantity") carries it, so
      // the row leads with the useful part — price and stock.
      info.innerHTML = '<div class="pdp-v2__onesize-sub"><strong>£' + size.price.toFixed(2) + ' per unit</strong>' +
        (size.stockKnown ? ' · ' + size.stock + ' in stock' : '') + '</div>';
      row.appendChild(info);
      var stepper = document.createElement('div');
      stepper.className = 'pdp-v2__size-cell__qty-row pdp-v2__onesize-stepper';
      var minusBtn = document.createElement('button');
      minusBtn.type = 'button';
      minusBtn.className = 'pdp-v2__size-cell__btn';
      minusBtn.textContent = '−';
      minusBtn.setAttribute('aria-label', 'Decrease quantity');
      minusBtn.disabled = qty <= 1;
      minusBtn.addEventListener('click', function() { self._updateQty(size.label, Math.max(1, qty - 1)); });
      var qtyDisplay = document.createElement('span');
      qtyDisplay.className = 'pdp-v2__size-cell__qty-display pdp-v2__size-cell__qty-display--has-qty';
      qtyDisplay.dataset.sizeLabel = size.label;
      qtyDisplay.textContent = qty;
      // The stepper is the primary control here (operator ruling 2026-08-31);
      // the number reads as a field — tabbable, labelled, tap/Enter to type.
      qtyDisplay.setAttribute('role', 'button');
      qtyDisplay.setAttribute('tabindex', '0');
      qtyDisplay.setAttribute('aria-label', 'Quantity ' + qty + ' — tap to type any amount');
      qtyDisplay.title = 'Tap to type a quantity';
      qtyDisplay.addEventListener('click', function() { self._startDirectInput(size.label); });
      qtyDisplay.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self._startDirectInput(size.label); }
      });
      var plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.className = 'pdp-v2__size-cell__btn';
      plusBtn.textContent = '+';
      plusBtn.setAttribute('aria-label', 'Increase quantity');
      plusBtn.disabled = qty >= stock;
      plusBtn.addEventListener('click', function() { if (qty < stock) self._updateQty(size.label, qty + 1); });
      stepper.appendChild(minusBtn);
      stepper.appendChild(qtyDisplay);
      stepper.appendChild(plusBtn);
      row.appendChild(stepper);
      grid.appendChild(row);

      // Any-quantity reassurance (operator ruling 2026-08-31): the boxes are
      // shortcuts, not the only options — say so explicitly.
      var anyLine = document.createElement('div');
      anyLine.className = 'pdp-v2__onesize-any';
      anyLine.textContent = 'Any quantity — discounts apply automatically';
      grid.appendChild(anyLine);

      // 2. Quick-quantity tier boxes — stock-aware, every reachable tier.
      // None render when stock is below the lowest tier: the block degrades
      // to the plain stepper above.
      if (reachable.length) {
        // Affordance label (operator ruling 2026-08-31): name the boxes and
        // say they are tappable — sighted users read them as cards otherwise.
        var tiersLabel = document.createElement('div');
        tiersLabel.className = 'pdp-v2__onesize-tiers-label';
        tiersLabel.textContent = 'Popular quantities — tap to select';
        grid.appendChild(tiersLabel);
        var boxes = document.createElement('div');
        boxes.className = 'pdp-v2__onesize-tiers';
        reachable.forEach(function(t) {
          var tierPrice = size.price * (1 - t.discount / 100);
          // Selected = the quantity IS this shortcut's exact amount. An odd
          // typed quantity (e.g. 17) selects no box — the message block, not
          // a box, reports the tier that applies.
          var picked = qty === t.minQty;
          var box = document.createElement('button');
          box.type = 'button';
          box.className = 'pdp-v2__onesize-tier' + (picked ? ' pdp-v2__onesize-tier--active' : '');
          box.setAttribute('aria-pressed', picked ? 'true' : 'false');
          box.setAttribute('aria-label', 'Select ' + t.minQty + ', ' + t.discount + '% off');
          box.innerHTML = '<span class="pdp-v2__onesize-tier-qty">' + t.minQty + '</span>' +
            '<span class="pdp-v2__onesize-tier-price">£' + tierPrice.toFixed(2) + ' each</span>' +
            '<span class="pdp-v2__onesize-tier-pct">' + t.discount + '% off</span>';
          box.addEventListener('click', function() { self._updateQty(size.label, t.minQty); });
          boxes.appendChild(box);
        });
        grid.appendChild(boxes);

        // 3. Message block — every figure computed from the tier data.
        var msg = document.createElement('div');
        var current = null;
        for (var i = 0; i < reachableAll.length; i++) { if (qty >= reachableAll[i].minQty) current = reachableAll[i]; }
        var nextTier = null;
        for (var j = 0; j < reachableAll.length; j++) { if (qty < reachableAll[j].minQty) { nextTier = reachableAll[j]; break; } }
        if (!current && nextTier) {
          var need = nextTier.minQty - qty;
          var np = size.price * (1 - nextTier.discount / 100);
          var saveTotal = size.price * (nextTier.discount / 100) * nextTier.minQty;
          msg.className = 'pdp-v2__onesize-msg pdp-v2__onesize-msg--nudge';
          msg.innerHTML = 'Add <strong>' + need + ' more</strong> to unlock ' + nextTier.discount +
            '% off at £' + np.toFixed(2) + ' per unit — save £' + saveTotal.toFixed(2) + ' total';
        } else if (current) {
          var cp = size.price * (1 - current.discount / 100);
          var saving = size.price * (current.discount / 100) * qty;
          msg.className = 'pdp-v2__onesize-msg pdp-v2__onesize-msg--success';
          var html = '<span class="pdp-v2__onesize-msg-line">✓ ' + current.discount + '% off applied — £' +
            cp.toFixed(2) + ' per unit, you save £' + saving.toFixed(2) + '</span>';
          if (nextTier) {
            var np2 = size.price * (1 - nextTier.discount / 100);
            html += '<span class="pdp-v2__onesize-msg-next">Add ' + (nextTier.minQty - qty) + ' more to reach ' +
              nextTier.discount + '% off at £' + np2.toFixed(2) + ' per unit</span>';
          }
          msg.innerHTML = html;
        }
        if (msg.className) grid.appendChild(msg);
      }
    }

    // ONE volume-eligibility gate (2026-09-01), evaluated from the Liquid
    // bootstrap flag (same tag predicate the drawer/trigger use). FAIL
    // CLOSED: only an explicit true qualifies — a missing flag shows no
    // discount UI. ~3,900 products get no garment volume discount at
    // checkout; every tier surface must key off THIS, never per-surface
    // conditions that can drift.
    _isVolumeEligible() {
      return !!(this._data && this._data.volumeDiscountEligible === true);
    }

    _calcTotal() {
      var colorName = this._state.selectedColor && this._state.selectedColor.name;
      var qtyMap = colorName && this._state.quantities[colorName] ? this._state.quantities[colorName] : {};
      var sizes = this._getSizesForColor(colorName || '');
      var totalQty = 0;
      var subtotal = 0;
      sizes.forEach(function(s) {
        var q = qtyMap[s.label] || 0;
        totalQty += q;
        subtotal += q * s.price;
      });
      // Ineligible products pay plain price at checkout — the running total,
      // CTA and sticky bar must say so (this was the worst surface: the buy
      // button showed a discounted figure checkout would not honour).
      if (!this._isVolumeEligible()) {
        return { totalQty: totalQty, subtotal: subtotal, discount: 0, discountAmount: 0, total: subtotal, tier: { minQty: 0, discount: 0, label: '' } };
      }
      var tiers = this._data.discountTiers || GARMENT_DISCOUNT_TIERS;
      var tier = tiers[0];
      for (var i = 0; i < tiers.length; i++) {
        if (totalQty >= tiers[i].minQty) tier = tiers[i];
      }
      var discountAmount = subtotal * (tier.discount / 100);
      var total = subtotal - discountAmount;
      return { totalQty: totalQty, subtotal: subtotal, discount: tier.discount, discountAmount: discountAmount, total: total, tier: tier };
    }

    _getNextTier(totalQty) {
      if (!this._isVolumeEligible()) return null;
      var tiers = this._data.discountTiers || GARMENT_DISCOUNT_TIERS;
      for (var i = 0; i < tiers.length; i++) {
        if (totalQty < tiers[i].minQty) return tiers[i];
      }
      return null;
    }

    // One-size test (shared): does a real size choice exist for the selected
    // colour? Same rule that enters one-size mode — the size option has
    // exactly one value — never the label text ("One Size", "O/S", "Standard"
    // all resolve the same way). Falls back to the first colour before one is
    // selected so step-1 chrome (the header size-guide link) is right too.
    _isOneSize() {
      var color = this._state.selectedColor || (this._colors && this._colors[0]);
      if (!color) return false;
      return this._getSizesForColor(color.name).length === 1;
    }

    // Size-guide links hide when no real size choice exists (operator ruling
    // 2026-08-31 — there are no size guides for one-size products). Both
    // placements carry [data-pdp-v2-size-guide]; the progress-header copy
    // hides via its wrapper so the header row keeps its layout.
    _syncSizeGuideVisibility() {
      var hide = this._isOneSize();
      this.querySelectorAll('[data-pdp-v2-size-guide]').forEach(function(link) {
        var target = link.closest('.bundle-size-guide-link-wrapper') || link;
        target.style.display = hide ? 'none' : '';
      });
    }

    _renderDiscountBar() {
      var block = this.querySelector('[data-pdp-v2-discount-bar]');
      if (!block) return;
      // One-size products drop the inline ramp entirely (operator ruling
      // 2026-08-31): the tier boxes carry the same ladder with actual prices,
      // and the ramp under-reports it (stale constant fallback). Gated here so
      // no update path can resurrect it. Ineligible products show NO ladder
      // at all — nothing to degrade into.
      if (this._isOneSize() || !this._isVolumeEligible()) { block.innerHTML = ''; return; }
      var tot = this._calcTotal();
      var fullTiers = this._data.discountTiers || GARMENT_DISCOUNT_TIERS;
      var maxQty = fullTiers[fullTiers.length - 1].minQty;
      var pct = maxQty > 0 ? Math.min(100, (tot.totalQty / maxQty) * 100) : 0;
      var displayTiers = fullTiers.filter(function(t) { return t.discount > 0; }).slice(0, 5);
      var html = '<div class="pdp-v2__discount-tier-row">';
      displayTiers.forEach(function(t, idx) {
        var reached = tot.totalQty >= t.minQty;
        var isLast = idx === displayTiers.length - 1;
        var posStyle = isLast ? 'right:0;left:auto' : 'left:' + (maxQty > 0 ? (t.minQty / maxQty) * 100 : 0) + '%';
        html += '<div class="pdp-v2__discount-tier-marker' + (isLast ? ' pdp-v2__discount-tier-marker--last' : '') + '" style="' + posStyle + '"><div class="pdp-v2__discount-tier-label' + (reached ? ' pdp-v2__discount-tier-label--reached' : '') + '">' + t.label + '</div><div class="pdp-v2__discount-tier-qty" style="color:' + (reached ? '#16a34a' : '#737373') + '">' + t.minQty + '+</div></div>';
      });
      html += '</div><div class="pdp-v2__discount-track"><div class="pdp-v2__discount-fill" style="width:' + pct + '%"></div></div>';
      var next = this._getNextTier(tot.totalQty);
      if (tot.totalQty > 0 && next) {
        var need = next.minQty - tot.totalQty;
        html += '<div class="pdp-v2__discount-nudge">Add ' + need + ' more to unlock <span class="pdp-v2__discount-nudge-green">extra ' + next.label + '</span></div>';
      } else if (tot.totalQty > 0 && !next) {
        var topTierLabel = tot.tier && tot.tier.label ? tot.tier.label : '';
        if (!topTierLabel) {
          var withDisc = fullTiers.filter(function(t) { return t.discount > 0; });
          if (withDisc.length) topTierLabel = withDisc[withDisc.length - 1].label || '';
        }
        html += '<div class="pdp-v2__discount-nudge" style="color:#16a34a">\u2713 Discount applied' + (topTierLabel ? ' \u2014 ' + topTierLabel : '') + '</div>';
      }
      block.innerHTML = html;
    }

    _renderRunningTotal() {
      var tot = this._calcTotal();
      var block = this.querySelector('[data-pdp-v2-running-total]');
      var helper = this.querySelector('[data-pdp-v2-helper-qty]');
      if (!block) return;
      if (tot.totalQty <= 0) {
        block.hidden = true;
        if (helper) helper.hidden = false;
        return;
      }
      if (helper) helper.hidden = true;
      block.hidden = false;
      var inner = block.querySelector('.pdp-v2__running-total-inner') || (function() {
        block.innerHTML = '<div class="pdp-v2__running-total-inner"><span class="pdp-v2__running-total-count" data-rt-count></span><div class="pdp-v2__running-total-right"><span class="pdp-v2__running-total-was" data-rt-was></span><span class="pdp-v2__running-total-price" data-rt-price></span><span class="pdp-v2__running-total-badge" data-rt-badge></span></div></div>';
        return block.querySelector('.pdp-v2__running-total-inner');
      })();
      if (!inner) return;
      var countEl = inner.querySelector('[data-rt-count]');
      var wasEl = inner.querySelector('[data-rt-was]');
      var priceEl = inner.querySelector('[data-rt-price]');
      var badgeEl = inner.querySelector('[data-rt-badge]');
      if (countEl) countEl.textContent = tot.totalQty + ' item' + (tot.totalQty !== 1 ? 's' : '') + ' selected';
      if (wasEl) {
        wasEl.style.display = tot.discount > 0 ? '' : 'none';
        wasEl.textContent = tot.discount > 0 ? '\u00a3' + tot.subtotal.toFixed(2) : '';
      }
      if (priceEl) priceEl.textContent = '\u00a3' + tot.total.toFixed(2);
      if (badgeEl) {
        badgeEl.style.display = tot.discount > 0 ? '' : 'none';
        badgeEl.textContent = tot.discount > 0 ? tot.discount + '% off' : '';
      }
    }

    // Minimal scroll so the in-form ATC is fully visible. No-op when it already
    // is, so repeated quantity changes never move the page. Clears the sticky
    // site header at the top and the PDP sticky footer at the bottom, and never
    // scrolls further than needed — the size grid directly above the button
    // stays in view.
    _revealAtcButton() {
      var btn = this.querySelector('[data-pdp-v2-atc]');
      if (!btn || btn.hidden || !btn.offsetParent) return;

      var headerSection = document.querySelector('#shopify-section-jrs-main-header') || document.querySelector('.jrs-main-header');
      var headerH = (headerSection && headerSection.offsetHeight) ? headerSection.offsetHeight : 0;
      var footer = this.querySelector('[data-pdp-v2-sticky-footer]');
      var footerH = (footer && !footer.hidden && footer.offsetHeight) ? footer.offsetHeight : 0;
      var gap = window.innerWidth <= 768 ? 16 : 12;

      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var safeTop = headerH + gap;
      var safeBottom = viewportH - footerH - gap;
      var rect = btn.getBoundingClientRect();
      var curY = window.pageYOffset || window.scrollY || 0;
      var targetY;

      if (rect.height > (safeBottom - safeTop)) targetY = curY + rect.top - safeTop;        // taller than the gap: show its top
      else if (rect.bottom > safeBottom) targetY = curY + rect.bottom - safeBottom;         // hidden below: reveal from the bottom
      else if (rect.top < safeTop) targetY = curY + rect.top - safeTop;                     // hidden under the header: reveal from the top
      else return;                                                                          // already fully visible: leave the page alone

      targetY = Math.max(0, Math.round(targetY));
      if (Math.abs(curY - targetY) <= 4) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: targetY, behavior: reduce ? 'auto' : 'smooth' });
    }

    _updateAtcButton() {
      var tot = this._calcTotal();
      var btn = this.querySelector('[data-pdp-v2-atc]');
      if (!btn) return;
      // Reveal the button the moment a selection makes it usable (0 -> n). Only
      // on that transition: later quantity edits must not yank the page around.
      var wasEmpty = this._atcPrevQty === undefined ? true : this._atcPrevQty <= 0;
      this._atcPrevQty = tot.totalQty;
      if (wasEmpty && tot.totalQty > 0) {
        var self = this;
        setTimeout(function() { self._revealAtcButton(); }, 60);
      }
      btn.disabled = tot.totalQty <= 0;
      btn.style.background = tot.totalQty > 0 ? 'var(--jrs-orange)' : 'var(--jrs-border)';
      btn.style.cursor = tot.totalQty > 0 ? 'pointer' : 'default';
      if (tot.totalQty > 0) {
        btn.innerHTML = 'Add Logo / Add to Cart <span class="pdp-v2__atc-btn-summary">' + tot.totalQty + ' items \u00b7 \u00a3' + tot.total.toFixed(2) + '</span>';
      } else {
        btn.textContent = 'Add Logo / Add to Cart';
      }
    }

    _renderProgress() {
      var step = this._state.step;
      var tot = this._calcTotal();
      var numEl = this.querySelector('[data-pdp-v2-step-num]');
      var fillEl = this.querySelector('[data-pdp-v2-progress-fill]');
      var headEl = this.querySelector('[data-pdp-v2-progress-heading]');
      if (numEl) numEl.textContent = step;
      if (fillEl) {
        var w = 0;
        if (step === 2 && tot.totalQty > 0) w = 100;
        else if (step === 2) w = 50;
        fillEl.style.width = w + '%';
      }
      if (headEl && this._data && this._data.productTitle) headEl.textContent = 'Configure Your Order';
      this._syncSizeGuideVisibility();
    }

    _renderStickyFooter() {
      var footer = this.querySelector('[data-pdp-v2-sticky-footer]');
      if (!footer) return;
      var step = this._state.step;
      var showFooter = step === 1 || step === 2;
      if (!showFooter) {
        footer.hidden = true;
        footer.dataset.visible = 'false';
        return;
      }
      footer.hidden = false;
      var tot = this._calcTotal();
      var swatch = this.querySelector('[data-pdp-v2-sticky-swatch]');
      var line1 = this.querySelector('[data-pdp-v2-sticky-line1]');
      var line2 = this.querySelector('[data-pdp-v2-sticky-line2]');
      var atc = this.querySelector('[data-pdp-v2-sticky-atc]');
      if (swatch && this._state.selectedColor) {
        var color = this._state.selectedColor;
        var useImage = color.image && color.image.trim();
        if (useImage) {
          swatch.style.backgroundImage = 'url(' + color.image + ')';
          swatch.style.backgroundSize = 'cover';
          swatch.style.backgroundPosition = 'center';
          swatch.style.backgroundColor = 'transparent';
          swatch.style.border = '1px solid var(--jrs-border)';
          swatch.classList.add('pdp-v2__sticky-swatch--image');
        } else {
          swatch.style.backgroundImage = '';
          swatch.style.backgroundSize = '';
          swatch.style.backgroundPosition = '';
          swatch.style.background = color.hex;
          swatch.style.border = isLightColor(color.hex) ? '1px solid var(--jrs-border)' : 'none';
          swatch.classList.remove('pdp-v2__sticky-swatch--image');
        }
      } else if (swatch) {
        var mainImg = (this._data && (this._data.mainProductImage || this._data.main_product_image)) ||
          (this._colors && this._colors[0] && this._colors[0].image && this._colors[0].image.trim()) ||
          '';
        mainImg = typeof mainImg === 'string' ? mainImg.trim() : '';
        if (mainImg && step === 1 && !this._state.selectedColor) {
          swatch.style.backgroundImage = 'url(' + mainImg + ')';
          swatch.style.backgroundSize = 'cover';
          swatch.style.backgroundPosition = 'center';
          swatch.style.backgroundColor = 'transparent';
          swatch.style.border = '1px solid var(--jrs-border)';
          swatch.classList.add('pdp-v2__sticky-swatch--image');
        } else {
          swatch.style.background = 'var(--jrs-border)';
          swatch.style.backgroundImage = '';
          swatch.style.border = 'none';
          swatch.classList.remove('pdp-v2__sticky-swatch--image');
        }
      }
      if (step === 1) {
        if (this._state.selectedColor) {
          var col = this._state.selectedColor;
          if (line1) line1.textContent = col.name;
          if (line2) {
            line2.innerHTML = '';
            var sizesForPrice = this._getSizesForColor(col.name);
            var minPrice = sizesForPrice.length ? Math.min.apply(null, sizesForPrice.map(function(s) { return s.price; })) : 0;
            line2.innerHTML = '<span style="font-size: 16px; font-weight: 700; color: var(--jrs-dark);">From \u00a3' + minPrice.toFixed(2) + '</span>';
          }
          if (atc) {
            atc.disabled = false;
            atc.removeAttribute('disabled');
            atc.style.background = 'var(--jrs-orange)';
            atc.style.cursor = 'pointer';
            atc.textContent = 'Continue to Size Selection';
            atc.removeAttribute('data-pdp-v2-sticky-action');
          }
        } else {
          if (line1) line1.textContent = this._data && this._data.productTitle ? this._data.productTitle : 'Select a colour';
          if (line2) line2.innerHTML = '';
          if (atc) {
            atc.disabled = false;
            atc.style.background = 'var(--jrs-orange)';
            atc.style.cursor = 'pointer';
            atc.textContent = 'Select colour';
            atc.setAttribute('data-pdp-v2-sticky-action', 'select-color');
          }
        }
      } else {
        if (tot.totalQty <= 0) {
          var col = this._state.selectedColor;
          if (line1) line1.textContent = col && col.name ? col.name + ' \u00b7 Select sizes' : 'Select sizes & quantities';
          if (line2) {
            var sizesForPrice = col ? this._getSizesForColor(col.name) : [];
            var minP = sizesForPrice.length ? Math.min.apply(null, sizesForPrice.map(function(s) { return s.price; })) : 0;
            line2.innerHTML = '<span style="font-size: 16px; font-weight: 700; color: var(--jrs-dark);">From \u00a3' + minP.toFixed(2) + '</span>';
          }
          if (atc) {
            atc.disabled = false;
            atc.removeAttribute('disabled');
            atc.style.background = 'var(--jrs-orange)';
            atc.style.cursor = 'pointer';
            atc.textContent = 'Select sizes';
            atc.setAttribute('data-pdp-v2-sticky-action', 'select-sizes');
          }
        } else {
          if (line1) line1.innerHTML = tot.totalQty + ' item' + (tot.totalQty !== 1 ? 's' : '') + (tot.discount > 0 ? ' \u00b7 <span style="color:var(--jrs-green);font-weight:600">' + tot.discount + '% off</span>' : '');
          if (line2) {
            line2.innerHTML = '';
            if (tot.discount > 0) {
              var was = document.createElement('span');
              was.style.fontSize = '12px';
              was.style.color = 'var(--jrs-muted)';
              was.style.textDecoration = 'line-through';
              was.textContent = '\u00a3' + tot.subtotal.toFixed(2) + ' ';
              line2.appendChild(was);
            }
            var totalSpan = document.createElement('span');
            totalSpan.style.fontSize = '16px';
            totalSpan.style.fontWeight = '700';
            totalSpan.style.color = 'var(--jrs-dark)';
            totalSpan.textContent = '\u00a3' + tot.total.toFixed(2);
            line2.appendChild(totalSpan);
            if (tot.discountAmount > 0) {
              var save = document.createElement('span');
              save.style.fontSize = '10.5px';
              save.style.color = 'var(--jrs-green)';
              save.style.fontWeight = '600';
              save.textContent = ' saving \u00a3' + tot.discountAmount.toFixed(2);
              line2.appendChild(save);
            }
          }
          if (atc) {
            atc.removeAttribute('data-pdp-v2-sticky-action');
            atc.disabled = false;
            atc.style.background = 'var(--jrs-orange)';
            atc.style.cursor = 'pointer';
            atc.textContent = 'Add Logo / Add to Cart';
          }
        }
      }
    }

    _onScroll() {
      var isEligibleStep = this._state.step === 1 || this._state.step === 2;
      var rect = this.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var formIsVisible = rect.top < viewportHeight && rect.bottom > 0;
      var show = isEligibleStep && !formIsVisible;
      if (show === this._state.stickyVisible) return;
      this._state.stickyVisible = show;
      var footer = this.querySelector('[data-pdp-v2-sticky-footer]');
      if (footer) {
        footer.hidden = !isEligibleStep;
        footer.dataset.visible = show ? 'true' : 'false';
      }
    }

    _onResize() {
      // The one-size swatch strip derives its capacity from container width —
      // recompute on resize (debounced). No-op on every other surface.
      var self = this;
      if (this._pvosResizeT) clearTimeout(this._pvosResizeT);
      this._pvosResizeT = setTimeout(function() {
        var bar = self.querySelector('[data-pdp-v2-preview-bar]');
        if (bar && !bar.hidden && self.querySelector('[data-pdp-v2-pvos]')) {
          self._renderPreviewBar();
        }
      }, 150);
    }

    _openDrawer() {
      this._state.drawerOpen = true;
      var drawer = this.querySelector('[data-pdp-v2-drawer]');
      if (drawer) {
        drawer.hidden = false;
        drawer.dataset.open = 'true';
        drawer.querySelector('[data-pdp-v2-drawer-title]').textContent = 'All Colours (' + this._colors.length + ')';
        this._renderDrawerGrid('');
        var self = this;
        drawer.querySelector('[data-pdp-v2-drawer-search]').value = '';
        drawer.querySelector('[data-pdp-v2-drawer-search]').addEventListener('input', function() {
          self._renderDrawerGrid(this.value);
        });
      }
      this._track('drawer_opened', { totalColors: this._colors.length });
    }

    _closeDrawer() {
      this._state.drawerOpen = false;
      var drawer = this.querySelector('[data-pdp-v2-drawer]');
      if (drawer) {
        drawer.dataset.open = 'false';
        drawer.hidden = true;
      }
    }

    _renderDrawerGrid(query) {
      var grid = this.querySelector('[data-pdp-v2-drawer-grid]');
      var empty = this.querySelector('[data-pdp-v2-drawer-empty]');
      if (!grid) return;
      var q = (query || '').toLowerCase();
      var list = q ? this._colors.filter(function(c) { return c.name.toLowerCase().indexOf(q) !== -1; }) : this._colors;
      grid.innerHTML = '';
      var self = this;
      list.forEach(function(c) {
        var pill = self._createColorPill(c);
        pill.querySelector('button[type="button"]').addEventListener('click', function() {
          self._selectColor(c);
          self._closeDrawer();
        });
        grid.appendChild(pill);
      });
      if (empty) {
        empty.hidden = list.length > 0;
        empty.querySelector('[data-pdp-v2-drawer-query]').textContent = query || '';
      }
      if (query) this._track('drawer_searched', { query: query });
    }

    _openPreview(color) {
      this._state.previewColor = color;
      this._scrollYBeforePreview = window.scrollY || document.documentElement.scrollTop;
      var modal = this.querySelector('[data-pdp-v2-modal]');
      if (modal) {
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('jrs-modal-active');
        var imgArea = this.querySelector('[data-pdp-v2-modal-image]');
        var footerName = this.querySelector('[data-pdp-v2-modal-name]');
        var footerSwatch = this.querySelector('[data-pdp-v2-modal-swatch]');
        if (imgArea) {
          imgArea.style.background = 'linear-gradient(135deg, ' + color.hex + '18, ' + color.hex + '55)';
          if (color.image && color.image.trim()) {
            imgArea.innerHTML = '';
            var loadingEl = document.createElement('div');
            loadingEl.className = 'pdp-v2__modal-loading';
            loadingEl.setAttribute('aria-hidden', 'true');
            loadingEl.innerHTML = '<span class="pdp-v2__modal-spinner" aria-hidden="true"></span><span class="pdp-v2__modal-loading-text">Loading...</span>';
            imgArea.appendChild(loadingEl);
            var img = document.createElement('img');
            img.src = color.image;
            img.alt = color.name;
            img.loading = 'eager';
            img.style.maxWidth = '100%';
            img.style.maxHeight = '100%';
            img.style.width = 'auto';
            img.style.height = 'auto';
            img.style.objectFit = 'contain';
            img.style.display = 'block';
            img.style.opacity = '0';
            img.style.position = 'absolute';
            var placeholderHtml = '<div class="pdp-v2__modal-placeholder" style="width:55%;height:65%;border-radius:16px;background:' + color.hex + ';box-shadow:0 12px 40px rgba(0,0,0,0.12);display:flex;align-items:center;justify-content:center;font-size:48px;color:' + (isLightColor(color.hex) ? '#737373' : 'rgba(255,255,255,0.3)') + '">\uD83D\uDC55</div>';
            var self = this;
            img.onload = function() {
              if (loadingEl.parentNode) loadingEl.remove();
              img.style.opacity = '1';
              img.style.position = '';
              // Detailed zoom (shared JRS.ImageZoom) on the colour preview,
              // matching the gallery lightbox: pinch / double-tap / wheel /
              // pan. Attached per open (image node is rebuilt each time);
              // destroyed in _closePreview.
              if (window.JRS && window.JRS.ImageZoom) {
                if (self._previewZoom) { self._previewZoom.destroy(); }
                self._previewZoom = window.JRS.ImageZoom.attach(imgArea, img, {
                  hint: window.JRS.ImageZoom.defaultHint()
                });
              }
            };
            img.onerror = function() {
              if (loadingEl.parentNode) loadingEl.remove();
              imgArea.innerHTML = placeholderHtml;
            };
            imgArea.appendChild(img);
          } else {
            imgArea.innerHTML = '<div style="width:55%;height:65%;border-radius:16px;background:' + color.hex + ';box-shadow:0 12px 40px rgba(0,0,0,0.12);display:flex;align-items:center;justify-content:center;font-size:48px;color:' + (isLightColor(color.hex) ? '#737373' : 'rgba(255,255,255,0.3)') + ';border:' + (isLightColor(color.hex) ? '2px solid #e5e5e5' : 'none') + '">\uD83D\uDC55</div>';
          }
        }
        if (footerName) footerName.textContent = color.name;
        if (footerSwatch) {
          var useImageSwatch = color.image && color.image.trim();
          footerSwatch.classList.toggle('pdp-v2__modal-swatch--image', !!useImageSwatch);
          if (useImageSwatch) {
            footerSwatch.style.backgroundColor = color.hex;
            footerSwatch.style.backgroundImage = 'url(' + color.image + ')';
            footerSwatch.style.backgroundSize = 'cover';
            footerSwatch.style.backgroundPosition = 'center';
            footerSwatch.style.border = 'none';
          } else {
            footerSwatch.style.backgroundImage = '';
            footerSwatch.style.backgroundColor = '';
            footerSwatch.style.background = color.hex;
            footerSwatch.style.border = isLightColor(color.hex) ? '1px solid var(--jrs-border)' : 'none';
          }
        }
      }
      this._track('color_previewed', { colorName: color.name, source: 'pill' });
    }

    _closePreview() {
      var scrollY = typeof this._scrollYBeforePreview === 'number' ? this._scrollYBeforePreview : 0;
      this._state.previewColor = null;
      if (this._previewZoom) { this._previewZoom.destroy(); this._previewZoom = null; }
      var modal = this.querySelector('[data-pdp-v2-modal]');
      if (modal) {
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
      }
      document.body.classList.remove('jrs-modal-active');
      if (scrollY > 0) {
        requestAnimationFrame(function() { window.scrollTo(0, scrollY); });
      }
    }

    /**
     * Syncs variant/quantity and color into the product form so initSingleAdd/addBulkItems
     * can read them. Contract: items[N][id], items[N][quantity], .mrk-qty-item with
     * data-variant-id, and options[Color] — do not change names/classes (betterconversions-customizer.js depends on them).
     */
    _syncHiddenInputs() {
      var container = this.querySelector('[data-pdp-v2-form-inputs]');
      if (!container) return;
      var colorName = this._state.selectedColor && this._state.selectedColor.name;
      var qtyMap = colorName && this._state.quantities[colorName] ? this._state.quantities[colorName] : {};
      var sizes = this._getSizesForColor(colorName || '');
      var form = this.closest('form');
      if (!form) return;
      container.innerHTML = '';
      var count = 0;
      sizes.forEach(function(s) {
        var q = qtyMap[s.label] || 0;
        if (q <= 0) return;
        var idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'items[' + count + '][id]';
        idInput.value = s.variantId;
        container.appendChild(idInput);
        var qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'items[' + count + '][quantity]';
        qtyInput.value = q;
        qtyInput.className = 'mrk-qty-item';
        qtyInput.dataset.variantId = s.variantId;
        qtyInput.setAttribute('data-variant-id', s.variantId);
        qtyInput.setAttribute('price', (s.price * 100).toString());
        container.appendChild(qtyInput);
        count++;
      });
      var colorNameForForm = colorName || (this._state.selectedColor && this._state.selectedColor.name);
      if (colorNameForForm) {
        var colorOpt = form.querySelector('input[name="options[Color]"], input[name="options[Colour]"]');
        if (colorOpt) {
          colorOpt.value = colorNameForForm;
          if (typeof colorOpt.checked !== 'undefined') colorOpt.checked = true;
        } else {
          var colorInput = document.createElement('input');
          colorInput.type = 'hidden';
          colorInput.name = 'options[Color]';
          colorInput.value = colorNameForForm;
          container.appendChild(colorInput);
        }
      }
    }

    _handleATC() {
      var tot = this._calcTotal();
      if (tot.totalQty <= 0) return;
      this._syncHiddenInputs();
      this._track('atc_clicked', { totalQty: tot.totalQty, total: tot.total, discount: tot.discount, colorName: this._state.selectedColor && this._state.selectedColor.name });
      var form = this.closest('form');
      var hasStep3 = this._data.hasStep3;
      var step3 = form && form.querySelector('.step-3');
      if (hasStep3 && step3) {
        step3.classList.remove('hidden');
        step3.hidden = false;
        var tick3 = step3.querySelector('.custom-product-form-tick');
        if (tick3) tick3.classList.add('selected');
        var details = step3.querySelector('details');
        if (details) details.setAttribute('open', '');
        var popupBtn = step3.querySelector('.mrk-open-popup') || document.getElementById('editLogo');
        if (popupBtn) {
          if (typeof window.mrknavigateTo === 'function') window.mrknavigateTo(0);
          if (typeof window.jQuery === 'function') window.jQuery('.mrk-steps-footer').addClass('hidden');
          window.setTimeout(function() { popupBtn.click(); }, 0);
        } else if (typeof window.mrknavigateTo === 'function') {
          window.mrknavigateTo(1);
        }
      } else {
        var addBtn = form && form.querySelector('.single-product__add-to-cart');
        if (addBtn) addBtn.click();
        else if (typeof window.initSingleAdd === 'function') window.initSingleAdd();
      }
    }

    _track(event, data) {
      try {
        var payload = data != null && typeof data === 'object' ? data : {};
        payload._debug_theme = typeof JRS_THEME_NAME !== 'undefined' ? JRS_THEME_NAME : 'unknown';
        payload._debug_build_version = typeof JRS_BUILD_VERSION !== 'undefined' ? JRS_BUILD_VERSION : 'unknown';
        var detail = { payload: payload };
        try {
          this.dispatchEvent(new CustomEvent('pdp-v2:' + event, { bubbles: true, detail: detail }));
        } catch (dispatchErr) {}
        if (window.dataLayer && Array.isArray(window.dataLayer)) {
          try {
            window.dataLayer.push({ event: 'pdp_v2_' + event, payload: payload });
          } catch (dlErr) {}
        }
      } catch (e) {}
    }
  }

  if (!customElements.get('pdp-multistep-form-v2')) {
    customElements.define('pdp-multistep-form-v2', PdpMultistepFormV2);
  }

  function injectFormFromBootstrap() {
    var mount = document.getElementById('pdp-v2-mount');
    if (!mount) return;
    var bootstrap = null;
    var configEl = document.getElementById('pdp-v2-bootstrap-config');
    if (configEl && configEl.textContent) {
      try {
        bootstrap = JSON.parse(configEl.textContent.trim());
      } catch (e) {}
    }
    if (!bootstrap) {
      var ds = mount.dataset;
      bootstrap = {
        productId: ds.productId || mount.getAttribute('data-product-id') || '',
        productHandle: (ds.productHandle || mount.getAttribute('data-product-handle') || '').trim(),
        productTitle: (ds.productTitle || mount.getAttribute('data-product-title') || '').trim(),
        colorOptionIndex: parseInt(ds.colorIndex || mount.getAttribute('data-color-index') || '0', 10),
        sizeOptionIndex: parseInt(ds.sizeIndex || mount.getAttribute('data-size-index') || '1', 10),
        hasStep3: (ds.hasStep3 || mount.getAttribute('data-has-step3') || '') === 'true',
        sectionId: ds.sectionId || mount.getAttribute('data-section-id') || ''
      };
    }
    if (!bootstrap.productHandle) return;

    function doInject(hexMapArray) {
      var fullConfig = {
        productId: bootstrap.productId,
        productHandle: bootstrap.productHandle,
        productTitle: bootstrap.productTitle,
        mainProductImage: bootstrap.mainProductImage || null,
        colorOptionIndex: bootstrap.colorOptionIndex,
        sizeOptionIndex: bootstrap.sizeOptionIndex,
        hexMapArray: Array.isArray(hexMapArray) ? hexMapArray : (Array.isArray(bootstrap.hexMapArray) ? bootstrap.hexMapArray : []),
        variantImagesArray: Array.isArray(bootstrap.variantImagesArray) ? bootstrap.variantImagesArray : [],
        variantInventory: bootstrap.variantInventory && typeof bootstrap.variantInventory === 'object' ? bootstrap.variantInventory : {},
        currencySymbol: '£',
        freeDeliveryThreshold: 150,
        discountTiers: bootstrap.discountTiers && bootstrap.discountTiers.length ? bootstrap.discountTiers : GARMENT_DISCOUNT_TIERS,
        // Volume-eligibility gate: pass through EXACTLY as served — the
        // consumer fails closed on anything but true.
        volumeDiscountEligible: bootstrap.volumeDiscountEligible === true,
        hasStep3: bootstrap.hasStep3
      };
      var configStr = JSON.stringify(fullConfig).replace(/<\/script>/gi, '\\u003c/script>');
      var sectionId = bootstrap.sectionId || '';
      var productId = bootstrap.productId || '';
      var inner = '<script type="application/json" data-pdp-v2-config>' + configStr + '<\/script>' +
        '<div class="pdp-v2__progress" data-pdp-v2-progress><div class="pdp-v2__progress-inner"><div class="pdp-v2__progress-title-group"><span class="pdp-v2__progress-heading" data-pdp-v2-progress-heading>Configure Your Order</span><div class="bundle-size-guide-link-wrapper pdp-v2__progress-size-guide" style="margin-left:8px;text-align:right;--size-guide-font-size-mobile:14px;--size-guide-font-weight-mobile:500;--size-guide-text-color:#555;--size-guide-text-color-hover:#333;--size-guide-icon-width-mobile:16px;--size-guide-icon-height-mobile:16px;--size-guide-icon-color:#555;--size-guide-icon-color-hover:#333;--size-guide-icon-gap-mobile:6px;--size-guide-arrow-width-mobile:12px;--size-guide-arrow-height-mobile:12px;--size-guide-arrow-color:#555;--size-guide-arrow-color-hover:#333;--size-guide-arrow-gap-mobile:4px;--size-guide-padding-top-mobile:8px;--size-guide-padding-bottom-mobile:8px;"><a href="#" class="bundle-size-guide-link" data-pdp-v2-size-guide aria-label="Size guide"><span class="bundle-size-guide-icon"><svg class="bundle-size-guide-ruler-icon" width="16" height="16" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g><circle fill="currentColor" cx="50" cy="21.014" r="2"/><path fill="currentColor" d="M62.838,17.992L46.021,1.175c-1.55-1.548-4.057-1.548-5.606,0l-2.102,2.104l4.204,4.203c0.388,0.387,0.388,1.015,0,1.401c-0.388,0.389-1.015,0.389-1.401,0l-4.204-4.204l-2.804,2.803l7.008,7.007c0.387,0.388,0.387,1.015,0,1.402c-0.388,0.387-1.015,0.387-1.401,0l-7.007-7.006l-2.803,2.802l4.203,4.204c0.388,0.387,0.388,1.014,0,1.4c-0.387,0.388-1.014,0.388-1.4,0l-4.204-4.203L25.7,15.891l4.205,4.203c0.387,0.388,0.387,1.014,0,1.402c-0.388,0.389-1.015,0.389-1.401-0.001l-4.205-4.204l-2.803,2.805l7.008,7.006c0.387,0.388,0.387,1.014,0,1.402c-0.389,0.387-1.015,0.387-1.402,0l-7.006-7.008l-2.804,2.803l4.204,4.204c0.388,0.388,0.388,1.015,0,1.402c-0.389,0.387-1.015,0.387-1.401,0L15.891,25.7l-2.803,2.804l4.204,4.204c0.387,0.386,0.387,1.013,0,1.4c-0.388,0.388-1.015,0.388-1.401,0l-4.204-4.203l-2.803,2.803l7.007,7.007c0.387,0.387,0.387,1.014,0,1.401c-0.388,0.387-1.015,0.387-1.402,0l-7.006-7.008l-2.804,2.804l4.204,4.204c0.389,0.387,0.389,1.015,0.001,1.401c-0.389,0.387-1.016,0.387-1.401,0l-4.204-4.204l-2.104,2.102c-1.549,1.549-1.549,4.056,0,5.606l16.817,16.816c1.549,1.55,4.057,1.55,5.606,0l39.24-39.239C64.388,22.049,64.388,19.541,62.838,17.992z M50,25.014c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S52.209,25.014,50,25.014z"/></g></svg></span><span class="bundle-size-guide-text">Size Guide</span><span class="bundle-size-guide-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 13L7 7L0.999999 1" stroke="currentColor"/></svg></span></a></div></div><span class="pdp-v2__progress-step" data-pdp-v2-progress-step>Step <span data-pdp-v2-step-num>1</span> / 2</span></div><div class="pdp-v2__progress-track"><div class="pdp-v2__progress-fill" data-pdp-v2-progress-fill style="width: 0%;"></div></div></div>' +
      '<div class="pdp-v2__step1" data-pdp-v2-step="1"><div class="pdp-v2__card pdp-v2__card--active"><h3 class="pdp-v2__heading">Choose Colour</h3><div class="pdp-v2__color-grid" data-pdp-v2-color-grid role="list"></div><div class="pdp-v2__show-more" data-pdp-v2-show-more hidden></div><button type="button" class="pdp-v2__continue-btn" data-pdp-v2-continue disabled>Continue to Size Selection \u2192</button><p class="pdp-v2__helper" data-pdp-v2-helper-disabled>Tap a colour to continue</p></div></div>' +
      '<div class="pdp-v2__step2" data-pdp-v2-step="2" hidden><div class="pdp-v2__desktop-layout" data-pdp-v2-desktop-layout><div class="pdp-v2__step2-right"><div class="pdp-v2__preview-bar" data-pdp-v2-preview-bar hidden><div class="pdp-v2__preview-bar-inner"><div class="pdp-v2__preview-bar-row"><div class="pdp-v2__preview-bar-image" data-pdp-v2-preview-image></div><div class="pdp-v2__preview-bar-info"><div class="pdp-v2__preview-bar-row1"><span class="pdp-v2__preview-bar-swatch" data-pdp-v2-preview-swatch></span><span class="pdp-v2__preview-bar-name" data-pdp-v2-preview-name></span></div><div class="pdp-v2__preview-bar-sizes" data-pdp-v2-preview-sizes></div><button type="button" class="pdp-v2__preview-bar-view" data-pdp-v2-preview-view>View full image →</button></div><div class="pdp-v2__preview-bar-aside"><span class="pdp-v2__preview-bar-price" data-pdp-v2-preview-price></span><button type="button" class="pdp-v2__preview-bar-change" data-pdp-v2-change-colour>Change colour</button></div></div><div class="pdp-v2__preview-bar-stats"><div class="pdp-v2__preview-bar-stat" data-pdp-v2-preview-stat-sizes></div><div class="pdp-v2__preview-bar-stat" data-pdp-v2-preview-stat-price></div><div class="pdp-v2__preview-bar-stat" data-pdp-v2-preview-stat-discount></div></div></div></div><div class="pdp-v2__color-summary-card"><div class="pdp-v2__color-summary" data-pdp-v2-color-summary></div></div><div class="pdp-v2__size-card"><div class="pdp-v2__size-card-head"><h3 class="pdp-v2__heading">Select Sizes & Quantities</h3><a href="#" class="pdp-v2__per-unit-size-guide" data-pdp-v2-size-guide>Size Guide</a></div><div class="pdp-v2__discount-bar" data-pdp-v2-discount-bar></div><div class="pdp-v2__size-grid" data-pdp-v2-size-grid></div><div class="pdp-v2__size-show-more" data-pdp-v2-size-show-more hidden></div><div class="pdp-v2__running-total" data-pdp-v2-running-total hidden></div><p class="pdp-v2__helper" data-pdp-v2-helper-qty>Use +/− or tap quantities to type directly</p><button type="button" class="pdp-v2__atc-btn" data-pdp-v2-atc disabled>Add Logo / Add to Cart</button></div></div></div></div>' +
      '<div class="pdp-v2__sticky-footer" data-pdp-v2-sticky-footer hidden><div class="pdp-v2__sticky-inner"><span class="pdp-v2__sticky-swatch" data-pdp-v2-sticky-swatch aria-hidden="true"></span><div class="pdp-v2__sticky-info"><div class="pdp-v2__sticky-line1" data-pdp-v2-sticky-line1></div><div class="pdp-v2__sticky-line2" data-pdp-v2-sticky-line2></div></div><button type="button" class="pdp-v2__sticky-atc" data-pdp-v2-sticky-atc disabled>Add Logo / Add to Cart</button></div></div>' +
      '<div class="pdp-v2__drawer" id="pdp-v2-drawer-' + productId + '" data-pdp-v2-drawer hidden aria-modal="true" role="dialog" aria-label="All colours"><div class="pdp-v2__drawer-backdrop" data-pdp-v2-drawer-close></div><div class="pdp-v2__drawer-panel"><div class="pdp-v2__drawer-header"><span class="pdp-v2__drawer-title" data-pdp-v2-drawer-title>All Colours (0)</span><button type="button" class="pdp-v2__drawer-close" data-pdp-v2-drawer-close aria-label="Close colour browser">✕</button></div><input type="text" class="pdp-v2__drawer-search" data-pdp-v2-drawer-search placeholder="Search colours..." aria-label="Search colours"><div class="pdp-v2__drawer-body"><div class="pdp-v2__drawer-grid" data-pdp-v2-drawer-grid></div><p class="pdp-v2__drawer-empty" data-pdp-v2-drawer-empty hidden>No colours match "<span data-pdp-v2-drawer-query></span>"</p></div></div></div>' +
      '<div class="jrs-modal pdp-v2__modal" id="pdp-v2-modal-' + productId + '" data-pdp-v2-modal aria-modal="true" role="dialog" aria-label="Image preview"><div class="jrs-modal__backdrop" data-pdp-v2-modal-close></div><div class="jrs-modal__container" data-pdp-v2-modal-card><button type="button" class="jrs-modal__close" data-pdp-v2-modal-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg></button><div class="jrs-modal__scroll"><div class="jrs-modal__content"><div class="pdp-v2__modal-image" data-pdp-v2-modal-image></div><div class="pdp-v2__modal-footer"><span class="pdp-v2__modal-swatch" data-pdp-v2-modal-swatch></span><span class="pdp-v2__modal-name" data-pdp-v2-modal-name></span></div></div></div></div></div>' +
        '<div class="pdp-v2__form-inputs" data-pdp-v2-form-inputs aria-hidden="true"></div>';
      var el = document.createElement('pdp-multistep-form-v2');
      el.className = 'pdp-v2';
      el.id = 'pdp-v2-' + productId;
      el.setAttribute('data-product-id', String(productId));
      el.setAttribute('data-section-id', String(sectionId));
      el.innerHTML = inner;
      mount.appendChild(el);
    }

    doInject(Array.isArray(bootstrap.hexMapArray) ? bootstrap.hexMapArray : []);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectFormFromBootstrap);
  } else {
    injectFormFromBootstrap();
  }
})();
